<template>
  <div>
    <div class="detalheProposta" v-if="dadosProposta">
      <div class="text-right flex justify-end pr-2">
        <a
          v-if="hasPolicyDocumentBonus"
          :href="dadosCotacao.addition_information.policy_document_bonus"
          target="_blank"
        >
          <vs-button
            v-tooltip="'Apólice Anterior'"
            color="primary"
            type="gradient"
            icon-pack="feather"
            icon="icon-file-text"
            class="mr-3 mb-2 btn-print"
            data-testId="open-previous-policy-button"
          >
          </vs-button>
        </a>

        <a
          v-if="hasInvoiceDocument"
          :href="dadosCotacao.vehicle.invoice_document"
          target="_blank"
        >
          <vs-button
            v-tooltip="'Nota Fiscal'"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-file-text"
            class="mr-3 mb-2 btn-print"
            data-testId="open-invoice-document-button"
          >
          </vs-button>
        </a>

        <vs-button
          v-if="
            dadosProposta.idTipoApolice === RCVAT() &&
            this.dadosRcvat.vehiclePlatesUrl
          "
          @click="download(dadosRcvat.vehiclePlatesUrl)"
          icon-pack="feather"
          icon="icon-download"
          color="primary"
          type="gradient"
          class="mr-3 mb-2 btn-print"
          v-tooltip="'Exportar placas'"
          data-testId="download-vehicle-plates-button"
        >
        </vs-button>

        <vs-button
          @click="openModalHistoricoMensageria()"
          icon-pack="feather"
          icon="icon-mail"
          class="mr-3 mb-2 btn-print purple-btn"
          v-tooltip="'Histórico de mensageria'"
          data-testId="show-messaging-logs-button"
        >
        </vs-button>

        <a
          v-if="
            !isMicroLifePolicy(dadosProposta.idTipoApolice) &&
            !isAutoPolicy(dadosProposta.idTipoApolice)
          "
          :href="
            dadosProposta.insurance_policy || dadosProposta.insurance_proposal
          "
          target="_blank"
        >
          <vs-button
            v-tooltip="'Proposta/Apólice'"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-file-text"
            class="mr-3 mb-2 btn-print"
            data-testId="open-contract-button"
          >
          </vs-button>
        </a>

        <vs-button
          v-if="isAutoPolicy(dadosProposta.idTipoApolice)"
          icon-pack="feather"
          icon="icon-file"
          color="success"
          type="gradient"
          class="mr-3 mb-2 btn-print"
          v-tooltip="'Documentos'"
          data-testId="open-documents-button"
          @click="openModalDocumentos()"
        >
        </vs-button>

        <vs-button
          v-if="$can($actionsDefault.Escrita, subjectPermission)"
          @click="editarProposta()"
          icon-pack="feather"
          :icon="editProposalIcon"
          color="warning"
          type="gradient"
          class="mr-3 mb-2 btn-print"
          v-tooltip="editProposalLabel"
          data-testId="edit-proposal-button"
        >
        </vs-button>

        <vs-button
          v-if="$can('Visualizar Logs', subjectPermission)"
          v-tooltip="'Logs de Integrações'"
          color="dark"
          type="gradient"
          class="mr-3 mb-2 btn-print"
          @click="exibeLogs()"
          icon-pack="feather"
          icon="icon-activity"
        >
        </vs-button>
      </div>

      <div
        v-if="
          (dadosProposta.idStatus === STATUS_PROPOSTA.EM_PROCESSO_VISTORIA.id ||
            dadosProposta.idStatus === STATUS_PROPOSTA.PENDENTE.id) &&
          exibirDetalhesVistoria
        "
      >
        <vs-card>
          <vs-alert color="danger" icon="new_releases">
            <span><b>Atenção: vistoria enviada com pendência!</b></span>
          </vs-alert>

          <div class="flex flex-wrap gap-2">
            <div
              v-for="item in itensNaoValidadosVistoria"
              :key="item.key"
              class="vs-col"
            >
              <vs-list>
                <vs-list-header
                  :icon="item.icon"
                  :title="item.title"
                  color="warning"
                ></vs-list-header>
                <vs-list-item
                  v-for="prop in item.propriedades"
                  :key="`${item.key}-${prop}`"
                  icon="close"
                  :title="prop"
                ></vs-list-item>
              </vs-list>
            </div>
          </div>
        </vs-card>
      </div>

      <div v-if="dadosProposta" class="printer">
        <div class="folha">
          <div slot="header">
            <center>
              <img :src="logo" style="max-width: 300px" />
              <Br />
              <Br />
            </center>
            <h3>Dados da Proposta</h3>
            <br />
          </div>
          <div>
            <table class="table table-bordered">
              <tr
                v-if="
                  dadosProposta &&
                  dadosProposta.idStatusApolice &&
                  dadosProposta.idStatusApolice !== POLICY_STATUSES.OPEN.id &&
                  [STATUS_PROPOSTA.FINALIZADO.id].includes(
                    dadosProposta.idStatus,
                  )
                "
              >
                <th class="uppercase">Nº da Apólice</th>
                <td>
                  {{
                    functions.formatStarNumber(
                      dadosProposta.policyNumber,
                      dadosProposta.idTipoApolice,
                      'POLICY',
                    )
                  }}
                </td>
              </tr>
              <tr v-if="dadosProposta.cnsegCi">
                <th class="uppercase">CI</th>
                <td>{{ dadosProposta.cnsegCi }}</td>
              </tr>
              <tr v-if="dadosProposta.proposalNumber">
                <th class="uppercase">Número da Proposta</th>
                <td>{{ dadosProposta.proposalNumber }}</td>
              </tr>
              <tr>
                <th class="uppercase">Número da Cotação</th>
                <td>{{ dadosProposta.idProposta }}</td>
              </tr>
              <tr>
                <th class="uppercase">Tipo</th>
                <td>{{ dadosProposta.tipoProposta }}</td>
              </tr>
              <tr v-if="dadosProposta.placaSubstituicao">
                <th class="uppercase">Placa Substituição</th>
                <td>
                  <p>{{ dadosProposta.placaSubstituicao }}</p>
                </td>
              </tr>
              <tr>
                <th class="uppercase">Status</th>
                <td>
                  {{ dadosProposta.nomeStatus }}
                  <span v-if="dadosProposta.dataAdesao">{{
                    formataData(dadosProposta.dataAdesao)
                  }}</span>
                </td>
              </tr>

              <tr v-if="dadosProposta.qtdRecusa">
                <th class="uppercase">Vistoria pendenciada</th>
                <td>
                  <p class="p-3">
                    {{
                      dadosProposta.qtdRecusa > 1
                        ? dadosProposta.qtdRecusa + ' vezes'
                        : dadosProposta.qtdRecusa + ' vez'
                    }}
                  </p>
                </td>
              </tr>

              <tr v-if="dadosProposta.motivoReprovacaoGeral">
                <th class="uppercase">Pendência na vistoria</th>
                <td>
                  <p class="bg-danger text-white p-3">
                    {{ dadosProposta.motivoReprovacaoGeral }}
                  </p>
                </td>
              </tr>
              <tr v-if="dadosProposta.createdAt">
                <th class="uppercase">Data da Cotação</th>
                <td>
                  {{
                    functions.formataDataHoraPadraoBR(dadosProposta.createdAt)
                  }}
                </td>
              </tr>
              <tr v-if="dadosProposta.proposalDate">
                <th class="uppercase">Data da Proposta</th>
                <td>
                  {{
                    functions.formataDataHoraPadraoBR(
                      dadosProposta.proposalDate,
                    )
                  }}
                </td>
              </tr>
              <tr v-if="dadosProposta.dataVistoria">
                <th class="uppercase">
                  {{
                    isLifePolicy(dadosProposta.idTipoApolice)
                      ? 'Data Envio da Documentação'
                      : 'Data da Vistoria'
                  }}
                </th>
                <td>
                  {{
                    functions.formataDataHoraPadraoBR(
                      dadosProposta.dataVistoria,
                    )
                  }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Origem</th>
                <td>{{ dadosProposta.origem }}</td>
              </tr>
              <tr v-if="dadosProposta.cotaTabela">
                <th class="uppercase">Faixa Tabela</th>
                <td>{{ dadosProposta.cotaTabela }}</td>
              </tr>
              <tr v-if="dadosProposta.produtos">
                <th class="uppercase">Produtos</th>
                <td>
                  <p v-for="item in dadosProposta.produtos" :key="item.id">
                    {{ item.nomeProduto }} ( {{ item.valor | currency }}
                    <span v-if="item.isMensal == true">/mês</span>)
                    <span v-if="item.nomePagamento"
                      >- {{ item.nomePagamento }}</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <th class="uppercase">Observação</th>
                <td>
                  {{ dadosProposta.observacao }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Valor</th>
                <td>
                  {{ somaValorTotalMes(dadosProposta.produtos) | currency }},
                  vencimento todo dia
                  {{ dadosProposta.diaVencimentoMensalidade }}
                </td>
              </tr>
              <!-- <tr>
                <th class="uppercase">Valor Entrada</th>
                <td>{{ somaValorTotal(dadosProposta.produtos) | currency }}</td>
              </tr> -->
              <tr v-if="dadosProposta.ipAceite">
                <th class="uppercase">Ip</th>
                <td>{{ dadosProposta.ipAceite }}</td>
              </tr>
              <tr v-if="dadosProposta.cupom">
                <th class="uppercase">Cupom Utilizado</th>
                <td>{{ dadosProposta.cupom }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="folha">
          <div slot="header">
            <h3>Segurado</h3>
            <br />
          </div>
          <div>
            <table
              class="table table-bordered"
              v-if="dadosProposta.dadosCliente"
            >
              <tr>
                <th class="uppercase">Nome</th>
                <td>{{ dadosProposta.dadosCliente.associado }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosCliente.tipo == 'Pessoa Física'">
                <th class="uppercase">Nome Social?</th>
                <td>
                  {{
                    dadosProposta.dadosCliente.associadoNomeSocial
                      ? 'Sim'
                      : 'Não'
                  }}
                </td>
              </tr>
              <tr v-if="dadosProposta.dadosCliente.associadoNomeSocial">
                <th class="uppercase">Nome Civil</th>
                <td>{{ dadosProposta.dadosCliente.associadoNomeCivil }}</td>
              </tr>
              <tr>
                <th class="uppercase">Email</th>
                <td>{{ dadosProposta.dadosCliente.email }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosCliente.telefone">
                <th class="uppercase">Telefone</th>
                <td>{{ dadosProposta.dadosCliente.telefone }}</td>
              </tr>
              <tr>
                <th class="uppercase">Endereço</th>
                <td>
                  {{ dadosProposta.dadosCliente.cep }}
                  -
                  {{ dadosProposta.dadosCliente.endereco }}
                  {{ dadosProposta.dadosCliente.numero }}
                  {{ dadosProposta.dadosCliente.complemento }}
                  -
                  {{ dadosProposta.dadosCliente.bairro }}
                  -
                  {{ dadosProposta.dadosCliente.cidade }} /
                  {{ dadosProposta.dadosCliente.estado }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Tipo</th>
                <td>{{ dadosProposta.dadosCliente.tipo }}</td>
              </tr>
              <tr>
                <th class="uppercase">
                  {{
                    dadosProposta.dadosCliente.tipo == 'Pessoa Física'
                      ? 'CPF'
                      : 'CNPJ'
                  }}
                </th>
                <td>{{ dadosProposta.dadosCliente.cpf }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosCliente.rg_ie">
                <th class="uppercase">
                  {{
                    dadosProposta.dadosCliente.tipo == 'Pessoa Física'
                      ? 'RG'
                      : 'IE'
                  }}
                </th>
                <td>{{ dadosProposta.dadosCliente.rg_ie }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosCliente.representanteLegal">
                <th class="uppercase">Representante Legal</th>
                <td>
                  {{ dadosProposta.dadosCliente.representanteLegal }} CPF:
                  {{ dadosProposta.dadosCliente.cpfRepresentante }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Data de Nascimento</th>
                <td>
                  {{
                    !dadosProposta.dadosCliente.dataNascimento ||
                    dadosProposta.dadosCliente.dataNascimento === 'Invalid date'
                      ? ''
                      : dadosProposta.dadosCliente.dataNascimento
                  }}
                </td>
              </tr>
              <tr v-if="dadosProposta.dadosCliente.cnh">
                <th class="uppercase">CNH</th>
                <td>
                  {{ dadosProposta.dadosCliente.cnh }} ({{
                    dadosProposta.dadosCliente.catCnh
                  }})
                  <br />
                  Vencimento {{ dadosProposta.dadosCliente.dataVencimentoCnh }}
                </td>
              </tr>
              <tr v-if="isNoAutoPolicy(dadosProposta.idTipoApolice)">
                <th class="uppercase">Assinatura</th>
                <td>
                  <img :src="dadosProposta.assinatura" class="assinatura" />
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="folha">
          <div slot="header">
            <h3>Veículo</h3>
            <br />
          </div>
          <div>
            <table
              class="table table-bordered"
              v-if="dadosProposta.dadosVeiculo"
            >
              <tr v-if="dadosProposta.isZero">
                <th class="uppercase">Zero KM</th>
                <td>
                  NF: {{ dadosProposta.nf }}
                  <Br />
                  Data:{{ dadosProposta.dataNf }}
                  <br />
                  valor: {{ dadosProposta.valorNf | currency }}
                </td>
              </tr>
              <tr v-if="dadosProposta.nomeGrupo">
                <th class="uppercase">Grupo</th>
                <td>{{ dadosProposta.nomeGrupo }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.veiculoMarca">
                <th class="uppercase">Marca</th>
                <td>{{ dadosProposta.dadosVeiculo.veiculoMarca }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.veiculoModelo">
                <th class="uppercase">Modelo</th>
                <td>{{ dadosProposta.dadosVeiculo.veiculoModelo }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.anoFabricacao">
                <th class="uppercase">Ano</th>
                <td>
                  {{
                    dadosProposta.dadosVeiculo.anoFabricacao == '32000'
                      ? '0Km'
                      : `${dadosProposta.dadosVeiculo.anoFabricacao} / ${dadosProposta.dadosVeiculo.anoModelo}`
                  }}
                </td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.placa">
                <th class="uppercase">Placa</th>
                <td>{{ dadosProposta.dadosVeiculo.placa }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.renavam">
                <th class="uppercase">Renavam</th>
                <td>{{ dadosProposta.dadosVeiculo.renavam }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.chassi">
                <th class="uppercase">Chassi</th>
                <td style="text-transform: uppercase">
                  {{ dadosProposta.dadosVeiculo.chassi }}
                </td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.combustivel">
                <th class="uppercase">Combustível</th>
                <td>{{ dadosProposta.dadosVeiculo.combustivel }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.cilindradas">
                <th class="uppercase">Cilindrada</th>
                <td>{{ dadosProposta.dadosVeiculo.cilindradas }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.codigoFipe">
                <th class="uppercase">Código Fipe</th>
                <td>{{ dadosProposta.dadosVeiculo.codigoFipe }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.cor">
                <th class="uppercase">Cor</th>
                <td>{{ dadosProposta.dadosVeiculo.cor }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.estadoPneu">
                <th class="uppercase">Estado do Pneu</th>
                <td>{{ dadosProposta.dadosVeiculo.estadoPneu }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.valorFipe">
                <th class="uppercase">Valor</th>
                <td>{{ dadosProposta.dadosVeiculo.valorFipe | currency }}</td>
              </tr>
              <tr v-if="dadosProposta.restricoes.length > 0">
                <th class="uppercase">Restrições</th>
                <td>
                  <p v-for="item in dadosProposta.restricoes" :key="item.id">
                    {{ item.descricao }}
                  </p>
                </td>
              </tr>
              <tr v-if="dadosProposta.acessorios.length > 0">
                <th class="uppercase">Acessórios</th>
                <td>
                  <p>
                    {{
                      dadosProposta.acessorios
                        .map((el) => {
                          return ' ' + el.descricao;
                        })
                        .toString()
                    }}
                  </p>
                </td>
              </tr>
              <tr v-if="dadosProposta.detalhesAcessorios">
                <th class="uppercase">Defeitos</th>
                <td>{{ dadosProposta.detalhesAcessorios }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div v-for="item in filtraFotos()" :key="item.id" class="folha">
          <h3>{{ item.nomePosicao }}</h3>
          <div class="m-2 mb-4" style="clear: both">
            <span>{{ item.location }}</span>
          </div>
          <br />
          <h5 v-if="item.aprovada == false" class="mb-3">
            Reprovada - {{ item.motivoReprovacao }}
          </h5>
          <br />
          <img
            :src="item.nome"
            class="foto"
            width="100%"
            style="max-height: 940px"
          />
        </div>
      </div>
      <div class="non-printer">
        <vs-row class="flex items-start" v-if="dadosProposta">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="4"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-card>
              <div slot="header">
                <h3>Dados da Proposta</h3>
              </div>
              <div>
                <table class="table table-bordered">
                  <tr
                    v-if="
                      dadosProposta &&
                      dadosProposta.idStatusApolice &&
                      dadosProposta.idStatusApolice !==
                        POLICY_STATUSES.OPEN.id &&
                      [
                        STATUS_PROPOSTA.FINALIZADO.id,
                        STATUS_PROPOSTA.APOLICE_FINALIZADA.id,
                        STATUS_PROPOSTA.APOLICE_CANCELADA.id,
                      ].includes(dadosProposta.idStatus)
                    "
                  >
                    <th class="uppercase">Nº da Apólice</th>
                    <td>
                      {{
                        functions.formatStarNumber(
                          dadosProposta.policyNumber,
                          dadosProposta.idTipoApolice,
                          'POLICY',
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.cnsegCi">
                    <th class="uppercase">CI</th>
                    <td>{{ dadosProposta.cnsegCi }}</td>
                  </tr>
                  <tr v-if="dadosProposta.proposalNumber">
                    <th class="uppercase">Nº da Proposta</th>
                    <td>
                      {{
                        functions.formatStarNumber(
                          dadosProposta.proposalNumber,
                          dadosProposta.idTipoApolice,
                          'PROPOSAL',
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th class="uppercase">Nº da Cotação</th>
                    <td>{{ dadosProposta.idProposta }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Tipo</th>
                    <td>{{ dadosProposta.tipoProposta }}</td>
                  </tr>
                  <tr v-if="dadosProposta.placaSubstituicao">
                    <th class="uppercase">Placa Substituição</th>
                    <td>
                      <p>{{ dadosProposta.placaSubstituicao }}</p>
                    </td>
                  </tr>
                  <tr>
                    <th class="uppercase">Status</th>
                    <td>
                      {{ dadosProposta.nomeStatus }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.creationType">
                    <th class="uppercase">Tipo de cotação</th>
                    <td>{{ isNewPolicy ? 'Seguro novo' : 'Endosso' }}</td>
                  </tr>
                  <tr v-if="!isNewPolicy && endorsementOperationType">
                    <th class="uppercase">Tipo de endosso</th>
                    <td>{{ endorsementOperationType }}</td>
                  </tr>
                  <tr v-if="!isNewPolicy && currentPolicyLink">
                    <th class="uppercase">Apólice Atual</th>
                    <td>
                      <a
                        :href="currentPolicyLink"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Visualizar</a
                      >
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.qtdRecusa">
                    <th class="uppercase">Vistoria pendenciada</th>
                    <td>
                      {{
                        `${dadosProposta.qtdRecusa} vez${
                          dadosProposta.qtdRecusa > 1 ? 'es' : ''
                        }`
                      }}
                    </td>
                  </tr>

                  <tr v-if="dadosProposta.motivoReprovacaoGeral">
                    <th class="uppercase">Pendência na vistoria</th>
                    <td>
                      <p class="bg-danger text-white p-3">
                        {{ dadosProposta.motivoReprovacaoGeral }}
                      </p>
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.createdAt">
                    <th class="uppercase">Data da Cotação</th>
                    <td>
                      {{
                        functions.formataDataHoraPadraoBR(
                          dadosProposta.createdAt,
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.proposalDate">
                    <th class="uppercase">Data da Proposta</th>
                    <td>
                      {{
                        functions.formataDataHoraPadraoBR(
                          dadosProposta.proposalDate,
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.dataVistoria">
                    <th class="uppercase">
                      {{
                        isLifePolicy(dadosProposta.idTipoApolice)
                          ? 'Data Envio da Documentação'
                          : 'Data da Vistoria'
                      }}
                    </th>
                    <td>
                      {{
                        functions.formataDataHoraPadraoBR(
                          dadosProposta.dataVistoria,
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.dataAdesao">
                    <th class="uppercase">Data da emissão</th>
                    <td>
                      <p>
                        {{
                          functions.formataDataHoraPadraoBR(
                            dadosProposta.dataAdesao,
                          )
                        }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="uppercase">Origem</th>
                    <td>{{ dadosProposta.origem }}</td>
                  </tr>
                  <tr v-if="dadosProposta.cotaTabela">
                    <th class="uppercase">Faixa Tabela</th>
                    <td>{{ dadosProposta.cotaTabela }}</td>
                  </tr>
                  <tr
                    v-if="
                      dadosProposta.valorCotaParticipacao ||
                      dadosProposta.valorParticipacaoMinimo
                    "
                  >
                    <th class="uppercase">
                      Franquia Casco
                      <!-- {{
                        agregado ? `Participação do Caminhão` : `Participação`
                      }} -->
                    </th>
                    <td>
                      <span> {{ franquiaCasco | currency }}</span>
                    </td>
                  </tr>
                  <!--tr v-if="dadosProposta.produtos.length > 0">
                  <th class="uppercase">Produtos</th>
                  <td>
                    <p v-for="item in dadosProposta.produtos"
                      :key="item.id">
                      {{ item.nomeProduto }} ( {{ item.valor | currency }}
                      <span v-if="item.isMensal == true">/mês</span>)
                      <span v-if="item.nomePagamento">- {{ item.nomePagamento
                      }}</span>
                    </p>
                  </td>
                </tr-->
                  <tr>
                    <th class="uppercase">Observação</th>
                    <td>
                      {{ dadosProposta.observacao }}
                    </td>
                  </tr>
                  <!-- <tr>
                    <th class="uppercase">Valor Entrada</th>
                    <td>
                      {{ somaValorTotal(dadosProposta.produtos) | currency }}
                    </td>
                  </tr> -->
                  <tr v-if="dadosProposta.ipAceite">
                    <th class="uppercase">Ip</th>
                    <td>{{ dadosProposta.ipAceite }}</td>
                  </tr>
                  <tr v-if="dadosProposta.cupom">
                    <th class="uppercase">Cupom Utilizado</th>
                    <td>{{ dadosProposta.cupom }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Responsável pela Vistoria</th>
                    <td>
                      {{ inspectionManager(dadosProposta) }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.vistoriaFeitaPeloConsultor">
                    <td
                      colspan="2"
                      class="bg-warning p-2 text-white text-center"
                    >
                      Vistoria feita pelo Consultor
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.regional">
                    <th class="uppercase">Corretora</th>
                    <td>{{ dadosProposta.regional }}</td>
                  </tr>
                  <tr v-if="dadosProposta.nomeDivisao">
                    <th class="uppercase">Assessoria</th>
                    <td>{{ dadosProposta.nomeDivisao }}</td>
                  </tr>
                  <tr v-if="formaPagamentoAtual">
                    <th class="uppercase">Forma de Pagamento</th>
                    <td>{{ formaPagamentoAtual.formaPagamento }}</td>
                  </tr>
                </table>
              </div>
              <div
                class="flex justify-end gap-1"
                slot="footer"
                v-if="
                  isOpenInspection &&
                  $can($actionsDefault.Escrita, subjectPermission) &&
                  responsavelVistoria
                "
              >
                <vs-button
                  v-tooltip="'Recusar Proposta'"
                  v-if="
                    $can(
                      PERMISSIONS_ACTIONS.REFUSE,
                      PERMISSIONS_NAMES.QUOTATIONS,
                    )
                  "
                  @click="openModalRefuseProposal = true"
                  type="gradient"
                  color="dark"
                  icon="highlight_off"
                  data-testId="reject-proposal-button"
                  class="large-icon-button"
                ></vs-button>
                <vs-button
                  v-tooltip="'Reprovar Vistoria'"
                  v-if="needsInspection"
                  @click="cotacaoReprovar()"
                  type="gradient"
                  color="danger"
                  icon="thumb_down"
                  data-testId="reject-inspection-button"
                ></vs-button>
                <vs-button
                  v-tooltip="'Aprovar Vistoria'"
                  v-if="isNewPolicy"
                  @click="confirmApproval()"
                  type="gradient"
                  color="success"
                  icon="thumb_up"
                  data-testId="approve-inspection-button"
                ></vs-button>
              </div>
            </vs-card>
          </vs-col>
          <br class="break" />
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="4"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-card>
              <div slot="header">
                <h3>Segurado</h3>
              </div>
              <div>
                <table
                  class="table table-bordered"
                  v-if="dadosProposta.dadosCliente"
                >
                  <tr>
                    <th class="uppercase">Nome</th>
                    <td>{{ dadosProposta.dadosCliente.associado }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosCliente.tipo == 'Pessoa Física'">
                    <th class="uppercase">Nome Social?</th>
                    <td>
                      {{
                        dadosProposta.dadosCliente.associadoNomeSocial
                          ? 'Sim'
                          : 'Não'
                      }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.dadosCliente.associadoNomeSocial">
                    <th class="uppercase">Nome Civil</th>
                    <td>{{ dadosProposta.dadosCliente.associadoNomeCivil }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Email</th>
                    <td>{{ dadosProposta.dadosCliente.email }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosCliente.telefone">
                    <th class="uppercase">Telefone</th>
                    <td>{{ dadosProposta.dadosCliente.telefone }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Celular</th>
                    <td>{{ dadosProposta.dadosCliente.celular }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">Endereço</th>
                    <td>
                      {{ dadosProposta.dadosCliente.cep }}
                      <br />
                      {{ dadosProposta.dadosCliente.endereco }}
                      {{ dadosProposta.dadosCliente.numero }}
                      {{ dadosProposta.dadosCliente.complemento }}
                      <br />
                      {{ dadosProposta.dadosCliente.bairro }}
                      <br />
                      {{ dadosProposta.dadosCliente.cidade }} /
                      {{ dadosProposta.dadosCliente.estado }}
                    </td>
                  </tr>
                  <tr>
                    <th class="uppercase">Tipo</th>
                    <td>{{ dadosProposta.dadosCliente.tipo }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">
                      {{
                        dadosProposta.dadosCliente.tipo == 'Pessoa Física'
                          ? 'CPF'
                          : 'CNPJ'
                      }}
                    </th>
                    <td>{{ dadosProposta.dadosCliente.cpf }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosCliente.rg_ie">
                    <th class="uppercase">
                      {{
                        dadosProposta.dadosCliente.tipo == 'Pessoa Física'
                          ? 'RG'
                          : 'IE'
                      }}
                    </th>
                    <td>{{ dadosProposta.dadosCliente.rg_ie }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosCliente.representanteLegal">
                    <th class="uppercase">Representante Legal</th>
                    <td>
                      {{ dadosProposta.dadosCliente.representanteLegal }} CPF:
                      {{ dadosProposta.dadosCliente.cpfRepresentante }}
                    </td>
                  </tr>
                  <tr>
                    <th class="uppercase">Data de Nascimento</th>
                    <td>
                      {{
                        !dadosProposta.dadosCliente.dataNascimento ||
                        dadosProposta.dadosCliente.dataNascimento ===
                          'Invalid date'
                          ? ''
                          : dadosProposta.dadosCliente.dataNascimento
                      }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.dadosCliente.cnh">
                    <th class="uppercase">CNH</th>
                    <td>
                      {{ dadosProposta.dadosCliente.cnh }} ({{
                        dadosProposta.dadosCliente.catCnh
                      }})
                      <br />
                      Vencimento
                      {{ dadosProposta.dadosCliente.dataVencimentoCnh }}
                    </td>
                  </tr>

                  <tr v-if="isNoAutoPolicy(dadosProposta.idTipoApolice)">
                    <th class="uppercase">Assinatura</th>
                    <td>
                      <img :src="dadosProposta.assinatura" class="assinatura" />
                    </td>
                  </tr>
                </table>
              </div>
            </vs-card>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="4"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-card v-if="dadosProposta.idTipoApolice === RCVAT()">
              <div slot="header">
                <h3>Detalhes RCVAT</h3>
              </div>
              <div>
                <table class="table table-bordered">
                  <tr>
                    <th class="uppercase">Valor Anual</th>
                    <td>{{ formatingPrice(dadosRcvat.annualValue) }}</td>
                  </tr>
                </table>
                <vs-collapse type="margin">
                  <vs-collapse-item
                    v-for="(vehicle, index) in dadosRcvat.vehicles"
                    :key="`collapse-item-${index}`"
                  >
                    <div slot="header">Coleção {{ index + 1 }}</div>
                    <table class="table table-bordered">
                      <tr>
                        <th class="uppercase">Quantidade</th>
                        <td>{{ vehicle.numberOfVehicles }}</td>
                      </tr>
                      <tr>
                        <th class="uppercase">Tipo</th>
                        <td>{{ vehicle.vehicleType }}</td>
                      </tr>
                      <tr>
                        <th class="uppercase">Grupo</th>
                        <td>{{ vehicle.vehicleGroup }}</td>
                      </tr>
                    </table>
                  </vs-collapse-item>
                </vs-collapse>
              </div>
            </vs-card>
            <vs-card v-if="isAutoPolicy(dadosProposta.idTipoApolice)">
              <div slot="header">
                <h3>Veículo</h3>
              </div>
              <div>
                <table
                  class="table table-bordered"
                  v-if="dadosProposta.dadosVeiculo"
                >
                  <tr v-if="dadosProposta.isZero">
                    <th class="uppercase">Zero KM</th>
                    <td>
                      NF: {{ dadosProposta.nf }}
                      <br />
                      {{ verificaEmpresa() ? 'Dt. emissão NF: ' : 'Data: ' }}
                      {{ dadosProposta.dataNf }}
                      <br />
                      Saiu da concessionária:
                      {{
                        dadosProposta.veiculoSaiuConcessionaria ? 'Sim' : 'Não'
                      }}
                      <br />
                      <span v-if="dadosProposta.dataVeiculoSaiuConcessionaria">
                        Dt. saída da concessionária:
                        {{
                          dadosProposta.dataVeiculoSaiuConcessionaria
                            | formatDate
                        }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="!verificarGrupo && dadosProposta.nomeGrupo">
                    <th class="uppercase">Grupo</th>
                    <td>{{ dadosProposta.nomeGrupo }}</td>
                  </tr>
                  <tr
                    v-if="
                      verificarGrupo && dadosProposta.vistoriaFeitaPeloConsultor
                    "
                  >
                    <td
                      colspan="2"
                      class="bg-danger p-3 text-white text-center font-bold"
                    >
                      Por favor, verifique o grupo do veículo
                    </td>
                  </tr>
                  <tr v-if="verificarGrupo && dadosProposta.nomeGrupo">
                    <th class="uppercase bg-danger text-white">Grupo</th>
                    <td class="bg-danger">
                      <div class="box text-white font-black">
                        {{ dadosProposta.nomeGrupo }}
                        <vs-button
                          v-if="
                            $can($actionsDefault.Escrita, subjectPermission)
                          "
                          @click="removePedidoRevisaoGrupo(), editarProposta()"
                          icon-pack="feather"
                          :icon="editProposalIcon"
                          color="warning"
                          type="gradient"
                          class="btn-print"
                          v-tooltip="editProposalLabel"
                          data-testId="edit-proposal-data-button"
                        >
                        </vs-button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.veiculoMarca">
                    <th class="uppercase">Marca</th>
                    <td>{{ dadosProposta.dadosVeiculo.veiculoMarca }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.veiculoModelo">
                    <th class="uppercase">Modelo</th>
                    <td>{{ dadosProposta.dadosVeiculo.veiculoModelo }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.anoFabricacao">
                    <th class="uppercase">Ano</th>
                    <td>
                      {{
                        dadosProposta.dadosVeiculo.anoFabricacao == '32000'
                          ? '0Km'
                          : `${dadosProposta.dadosVeiculo.anoFabricacao} / ${dadosProposta.dadosVeiculo.anoModelo}`
                      }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.placa">
                    <th class="uppercase">Placa</th>
                    <td>{{ dadosProposta.dadosVeiculo.placa }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.renavam">
                    <th class="uppercase">Renavam</th>
                    <td>{{ dadosProposta.dadosVeiculo.renavam }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.chassi">
                    <th class="uppercase">Chassi</th>
                    <td style="text-transform: uppercase">
                      {{ dadosProposta.dadosVeiculo.chassi }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.combustivel">
                    <th class="uppercase">Combustivel</th>
                    <td>{{ dadosProposta.dadosVeiculo.combustivel }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.tipoCambio">
                    <th class="uppercase">Tipo de Câmbio</th>
                    <td>{{ dadosProposta.dadosVeiculo.tipoCambio }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.numeroMotor">
                    <th class="uppercase">Número do Motor</th>
                    <td>{{ dadosProposta.dadosVeiculo.numeroMotor }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.cilindradas">
                    <th class="uppercase">Cilindrada</th>
                    <td>{{ dadosProposta.dadosVeiculo.cilindradas }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.codigoFipe">
                    <th class="uppercase">Codigo Fipe</th>
                    <td>{{ dadosProposta.dadosVeiculo.codigoFipe }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.cor">
                    <th class="uppercase">Cor</th>
                    <td>{{ dadosProposta.dadosVeiculo.cor }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.estadoPneu">
                    <th class="uppercase">Estado do Pneu</th>
                    <td>{{ dadosProposta.dadosVeiculo.estadoPneu }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.valorFipe">
                    <th class="uppercase">Valor</th>
                    <td>
                      {{ dadosProposta.dadosVeiculo.valorFipe | currency }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.restricoes.length > 0">
                    <th class="uppercase">Restrições</th>
                    <td>
                      <p
                        v-for="item in dadosProposta.restricoes"
                        :key="item.id"
                      >
                        {{ item.descricao }}
                      </p>
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.acessorios.length > 0">
                    <th class="uppercase">Acessórios</th>
                    <td>
                      <p>
                        {{
                          dadosProposta.acessorios
                            .map((el) => {
                              return ' ' + el.descricao;
                            })
                            .toString()
                        }}
                      </p>
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.detalhesAcessorios">
                    <th class="uppercase">Defeitos</th>
                    <td>{{ dadosProposta.detalhesAcessorios }}</td>
                  </tr>
                </table>
              </div>
            </vs-card>
            <vs-card v-if="isLifePolicy(dadosProposta.idTipoApolice)">
              <div slot="header">
                <h3>Beneficiários</h3>
              </div>
              <table class="table table-bordered">
                <tr>
                  <th class="uppercase">Tipo de beneficiários</th>
                  <td>
                    {{
                      dadosProposta.beneficiariosVida.length > 0
                        ? 'Beneficiários indicados'
                        : 'Herdeiros legais'
                    }}
                  </td>
                </tr>
              </table>
              <div v-for="item in dadosProposta.beneficiariosVida">
                <vs-collapse class="mb-3" type="border">
                  <vs-collapse-item>
                    <div slot="header">{{ item.name }}</div>
                    <vs-row>
                      <table class="table table-bordered">
                        <tr>
                          <th class="uppercase">Nome Completo</th>
                          <td>
                            {{ item.name }}
                          </td>
                        </tr>
                        <tr>
                          <th class="uppercase">Grau de Parentesco</th>
                          <td>
                            {{ getKinshipLabel(item.kinship) }}
                          </td>
                        </tr>
                        <tr>
                          <th class="uppercase">Data de Nascimento</th>
                          <td>
                            {{ formataApenasData(item.birthdate) }}
                          </td>
                        </tr>
                        <tr>
                          <th class="uppercase">Participação (%)</th>
                          <td>
                            {{ item.percentage }}
                          </td>
                        </tr>
                      </table>
                    </vs-row>
                  </vs-collapse-item>
                </vs-collapse>
              </div>
            </vs-card>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="4"
            vs-sm="4"
            vs-xs="12"
          >
          </vs-col>
        </vs-row>

        <vs-row v-if="dadosProposta.produtos">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card
              v-if="
                isAutoPolicy(dadosProposta.idTipoApolice) ||
                isRcvatPolicy(dadosProposta.idTipoApolice)
              "
            >
              <div slot="header">
                <h3>Coberturas/Serviços</h3>
              </div>
              <table class="table table-bordered">
                <tr>
                  <th style="width: 60%">Nome Produto</th>
                  <th style="width: 40%">Prêmio</th>
                </tr>
                <tr v-for="item in productsFilters" :key="item.id">
                  <td>{{ functions.getAutoProductLabel(item) }}</td>
                  <td>
                    <b>{{ functions.formataReal(item.prize.prize) }}</b>
                  </td>
                </tr>
              </table>
            </vs-card>
            <vs-card v-if="isLifePolicy(dadosProposta.idTipoApolice)">
              <div slot="header">
                <h3>Coberturas/ Serviços</h3>
              </div>
              <table class="table table-bordered">
                <tr>
                  <th>Nome Produto</th>
                  <th class="hidden sm:block">Tipo</th>
                  <th>Prêmio</th>
                </tr>
                <tr v-for="item in productsFilters" :key="item.id">
                  <td>{{ item.productName }}</td>
                  <td class="hidden sm:block">
                    {{ item.is_required ? 'Obrigatório' : 'Opcional' }}
                  </td>
                  <td>
                    <b>{{ functions.formataReal(item.prize.prize) }}</b>
                  </td>
                </tr>
              </table>
            </vs-card>
          </vs-col>
        </vs-row>
        <!-- Implementos -->
        <vs-row v-if="implemento">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card>
              <div slot="header">
                <h3>Implementos</h3>
              </div>
              <vs-collapse type="border">
                <vs-collapse-item
                  v-for="item in implementos"
                  :key="item.idPropostaComplemento"
                >
                  <div slot="header">
                    <b
                      >{{ item.descricao ? `${item.descricao}` : '' }}
                      {{ item.marca }} {{ item.modelo }}</b
                    >
                  </div>
                  <vs-card>
                    <table class="table table-bordered">
                      <tr v-if="item.placa">
                        <th class="uppercase">Placa do Implemento</th>
                        <td>{{ item.placa }}</td>
                      </tr>
                      <tr v-if="item.tipo">
                        <th class="uppercase">Tipo de Implemento</th>
                        <td>{{ item.tipo }}</td>
                      </tr>
                      <tr v-if="item.marca">
                        <th class="uppercase">Marca do Implemento</th>
                        <td>{{ item.marca }}</td>
                      </tr>
                      <tr v-if="item.modelo">
                        <th class="uppercase">Modelo do Implemento</th>
                        <td>{{ item.modelo }}</td>
                      </tr>
                      <tr v-if="item.observacao">
                        <th class="uppercase">Observações</th>
                        <td>{{ item.observacao }}</td>
                      </tr>
                    </table>
                  </vs-card>
                </vs-collapse-item>
              </vs-collapse>
            </vs-card>
          </vs-col>
        </vs-row>

        <!-- Agregados -->
        <vs-row v-if="agregado">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card>
              <div slot="header">
                <h3>Agregados</h3>
              </div>
              <vs-collapse type="border">
                <vs-collapse-item
                  v-for="item in agregados"
                  :key="item.idPropostaComplemento"
                >
                  <div slot="header">
                    <b
                      >{{ item.placa ? `${item.placa} ` : '' }}
                      {{
                        item.chassi && !item.placa ? `${item.chassi} | ` : ''
                      }}</b
                    >
                    {{ item.marca }} {{ item.modelo }}
                  </div>
                  <vs-row>
                    <vs-card>
                      <table class="table table-bordered">
                        <tr v-if="item.descricaoAgregado">
                          <th class="uppercase">Descrição do agregado</th>
                          <td>{{ item.descricao }}</td>
                        </tr>
                        <tr v-if="item.placa">
                          <th class="uppercase">Placa</th>
                          <td>{{ item.placa }}</td>
                        </tr>
                        <tr v-if="item.chassi">
                          <th class="uppercase">Chassi</th>
                          <td>{{ item.chassi }}</td>
                        </tr>
                        <tr v-if="item.marca">
                          <th class="uppercase">Marca</th>
                          <td>{{ item.marca }}</td>
                        </tr>
                        <tr v-if="item.modelo">
                          <th class="uppercase">Modelo</th>
                          <td>{{ item.modelo }}</td>
                        </tr>
                        <tr
                          v-if="
                            item.valorCotaParticipacao ||
                            item.valorParticipacaoMinimo
                          "
                        >
                          <th class="uppercase">
                            Franquia Casco
                            <!-- {{
                        agregado ? `Participação do Caminhão` : `Participação`
                      }} -->
                          </th>
                          <td>
                            <span> {{ franquiaCasco | currency }}</span>
                          </td>
                        </tr>
                        <tr v-if="item.observacao">
                          <th class="uppercase">Observações</th>
                          <td>{{ item.observacao }}</td>
                        </tr>
                      </table>
                    </vs-card>
                  </vs-row>

                  <vs-row class="mt-5">
                    <vs-card>
                      <div slot="header">
                        <h3>Produtos</h3>
                      </div>
                      <table class="table table-bordered">
                        <tr>
                          <th>Nome Produto</th>
                          <th>Tipo</th>
                          <th>Valor Inicial</th>
                          <th>Valor Desconto</th>
                          <th>Valor Final</th>
                          <th>Forma de Pagamento</th>
                        </tr>
                        <tr
                          v-for="prodAgregado in filtraProdutosSelecionadosAgregado(
                            item.idPropostaComplemento,
                          )"
                          :key="prodAgregado.idProduto"
                        >
                          <td>{{ prodAgregado.nomeProduto }}</td>
                          <td>
                            {{
                              prodAgregado.obrigatorio
                                ? 'Obrigatório'
                                : 'Opcional'
                            }}
                            - {{ prodAgregado.isMensal ? 'Mensal' : 'À vista' }}
                          </td>
                          <td>
                            <span
                              v-if="prodAgregado.descontoConcedido > 0"
                              style="text-decoration: line-through"
                              >{{ prodAgregado.valor | currency }}</span
                            >
                            <span v-else>{{
                              prodAgregado.valor | currency
                            }}</span>
                          </td>
                          <td>
                            {{ prodAgregado.descontoConcedido | currency }}
                          </td>
                          <td>
                            <b>{{ prodAgregado.valorFinal | currency }}</b>
                          </td>
                          <td>{{ prodAgregado.nomePagamento }}</td>
                        </tr>
                      </table>
                    </vs-card>
                  </vs-row>
                </vs-collapse-item>
              </vs-collapse>
            </vs-card>
          </vs-col>
        </vs-row>

        <vs-row v-if="dadosFinanceiros.length > 0">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card>
              <div slot="header">
                <h3>Dados Financeiros</h3>
              </div>
              <vs-collapse type="border">
                <vs-collapse-item
                  v-for="item in dadosFinanceiros"
                  :key="item.id"
                >
                  <div slot="header">
                    Cobrança número:{{ item.id_registroFinanceiro }} -
                    {{ item.formaPagamento }}
                    <vs-chip
                      class="mr-4"
                      :color="getStatusBoletoColor(item.nomeStatus)"
                      >{{ item.nomeStatus }}
                    </vs-chip>
                    <vs-chip
                      v-if="validaVencido(item)"
                      class="mr-4"
                      color="danger"
                      >Vencido
                    </vs-chip>
                  </div>
                  <vs-row>
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-w="12"
                      vs-sm="12"
                      vs-xs="12"
                    >
                      <table class="table table-bordered">
                        <tr v-if="item.nossoNumero">
                          <th class="uppercase">Nosso Número</th>
                          <td>{{ item.nossoNumero }}</td>
                        </tr>
                        <tr>
                          <th class="uppercase">Data de Emissão</th>
                          <td>
                            {{ formataDataUTCAux(item.createdAt) }}
                          </td>
                        </tr>
                        <tr>
                          <th class="uppercase">Data de Vencimento</th>
                          <td>
                            {{ formataDataUTCAux(item.dataVencimento) }}
                          </td>
                        </tr>
                        <tr v-if="item.dataPagamento">
                          <th class="uppercase">Data de Pagamento</th>
                          <td>
                            {{ formataDataUTCAux(item.dataPagamento) }}
                          </td>
                        </tr>
                        <tr>
                          <th
                            v-if="!isLifePolicy(dadosProposta.idTipoApolice)"
                            class="uppercase"
                          >
                            Custo Mensal
                          </th>
                          <td>{{ item.valor | currency }}</td>
                        </tr>
                        <tr v-if="item.linhaDigitavel">
                          <th class="uppercase">Linha Digitavel</th>
                          <td>{{ item.linhaDigitavel }}</td>
                        </tr>
                        <tr v-if="item.linkBoleto">
                          <th class="uppercase">Link Boleto</th>
                          <td v-html="formataLink(item.linkBoleto)"></td>
                        </tr>
                        <tr v-if="item.pixImage">
                          <th class="uppercase">Pix Qr Imagem</th>
                          <td><img :src="item.pixImage" /></td>
                        </tr>
                        <tr v-if="item.pixQrCode">
                          <th class="uppercase">Pix Qr Code</th>
                          <td>{{ item.pixQrCode }}</td>
                        </tr>
                      </table>
                    </vs-col>
                  </vs-row>
                </vs-collapse-item>
              </vs-collapse>
            </vs-card>
          </vs-col>
        </vs-row>
        <br class="break" />
        <div
          v-if="fotosGerais.length >= 1"
          class="flex justify-end mt-2 text-right mb-4"
        >
          <div
            v-if="
              responsavelVistoria &&
              $can($actionsDefault.Escrita, subjectPermission) &&
              filtraFotos().length > 0 &&
              dadosProposta.idStatus != STATUS_PROPOSTA.FINALIZADO.id &&
              isOpenInspection
            "
          >
            <vs-button
              color="success"
              type="border"
              class="mr-3"
              @click="
                promptAprovarReprovar = true;
                isAprovarTodas = true;
              "
              data-testId="approve-all-button"
            >
              <vs-icon icon="thumb_up" class="mr-3"></vs-icon>
              Aprovar Todas
            </vs-button>

            <vs-button
              color="danger"
              type="border"
              class="mr-3"
              @click="
                promptAprovarReprovar = true;
                isAprovarTodas = false;
              "
              data-testId="reject-all-button"
            >
              <vs-icon icon="thumb_down" class="mr-3"></vs-icon>
              Reprovar Todas
            </vs-button>
          </div>

          <vs-button
            color="warning"
            type="border"
            class="mr-3"
            @click="modalUpload = true"
            v-if="verificaPermissaoUpload()"
            data-testId="manual-upload-button"
          >
            <vs-icon icon-pack="feather" icon="icon-upload"></vs-icon>
            Upload Manual
          </vs-button>

          <vs-button
            color="warning"
            type="border"
            class="mr-3"
            @click="modalUpload = true"
            v-if="
              (($can('Upload', subjectPermission) &&
                dadosProposta.idStatus !==
                  STATUS_PROPOSTA.AGUARDANDO_APROVACAO.id) ||
                ($can(
                  'Acesso ao Upload Manual no status Aguardando Aprovação',
                  subjectPermission,
                ) &&
                  $can('Upload', subjectPermission) &&
                  dadosProposta.idStatus ===
                    STATUS_PROPOSTA.AGUARDANDO_APROVACAO.id)) &&
              !verificaEmpresa()
            "
            data-testId="manual-upload-waiting-approval-button"
          >
            <vs-icon icon-pack="feather" icon="icon-upload"></vs-icon>
            Upload Manual
          </vs-button>
        </div>
        <vs-row>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <vs-card class="cardFotos">
              <div slot="header">
                <h3>
                  Fotos
                  <vs-select
                    class="float-right filtroFotos"
                    label="Filtro Por:"
                    v-model="filtroFoto"
                    data-testId="photos-select"
                  >
                    <vs-select-item
                      :key="item"
                      :value="item"
                      :text="item"
                      v-for="item in tiposFotos"
                    />
                  </vs-select>

                  <br style="clear: both" />
                </h3>
              </div>
              <div>
                <div
                  v-if="filtraFotos().length == 0"
                  class="flex justify-center"
                >
                  <h4>Não há itens a serem exibidos para esse filtro.</h4>
                </div>
                <vs-row
                  v-if="filtraFotos().length > 0"
                  class="mt-5"
                  vs-justify="center"
                >
                  <vs-col
                    v-for="item in filtraFotos()"
                    :key="item.id"
                    type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="3"
                    vs-sm="3"
                    vs-xs="12"
                    class="mb-4"
                  >
                    <vs-card :class="verificaBg(item)">
                      <div slot="header">
                        <h3>
                          {{ item.nomePosicao }}

                          <vs-button
                            v-tooltip="'Visualizar Padrão'"
                            @click="openModalFoto('Padrão', item)"
                            class="float-right"
                            type="gradient"
                            color="dark"
                            icon="info"
                            data-testId="open-photo-popup-button"
                          ></vs-button>
                        </h3>
                      </div>
                      <div>
                        <div class="m-2 mb-4" style="clear: both">
                          <vs-button
                            v-tooltip="'Visualizar Mapa'"
                            v-if="item.latitude"
                            @click="openModalMap(item)"
                            class="float-left mr-2"
                            type="gradient"
                            color="primary"
                            icon-pack="feather"
                            icon="icon-map-pin"
                            data-testId="view-map-popoup-button"
                          ></vs-button>
                          <span
                            v-if="item.nome"
                            :class="`${
                              item.aprovada == null ? '' : 'text-white'
                            }`"
                          >
                            <span>{{ item.location }}</span>
                            <p v-if="item.dataFoto">
                              Sincronizada em:
                              {{
                                verificaSefotoFoiAtualizada(
                                  item.dataFoto,
                                  item.dataAtualizacao,
                                )
                              }}
                            </p>
                            <p v-if="item.dataFotoCaptura">
                              Capturada em:
                              {{ formataData(item.dataFotoCaptura) }}
                            </p>
                            <p v-if="item.analysisResponsibleId">
                              Analisada por:
                              {{ item.analysisResponsibleId }} -
                              {{ item.analysisResponsibleName }} em
                              {{ formataData(item.analysisDate) }}
                            </p></span
                          >
                        </div>
                        <div
                          v-if="item.userUploadedName"
                          class="m-2 mb-4"
                          style="clear: both"
                          :class="`${
                            item.aprovada == null ? '' : 'text-white'
                          }`"
                        >
                          Upload por: {{ item.userUploadedName }}
                        </div>

                        <video
                          class="video"
                          style="max-height: 130px; margin: auto; display: flex"
                          v-if="verificaExtensaoVideo(item.nome)"
                          controls
                          muted
                          loop
                          :src="item.nome"
                        ></video>

                        <img
                          @click="openModalFoto('Foto', item)"
                          v-if="verificaExtensaoImagem(item.nome)"
                          :src="item.nome"
                          class="foto"
                          width="100%"
                          data-testId="open-photo-popup-button"
                        />

                        <div
                          v-else-if="!verificaExtensaoVideo(item.nome)"
                          class="flex flex-col items-center"
                        >
                          <img
                            @click="openDocument(item.nome)"
                            class="foto"
                            width="80%"
                            src="../../../src/assets/images/elements/PDF_file_icon2.png"
                          />
                          <vs-button
                            @click="openDocument(item.nome)"
                            class="mt-2"
                            type="gradient"
                            color="dark"
                            data-testId="open-document-button"
                            >Visualizar</vs-button
                          >
                        </div>

                        <div v-if="item.observacaoVistoria">
                          <span
                            :class="`${
                              item.aprovada == null ? '' : 'text-white'
                            }`"
                            ><b>Observação:</b></span
                          >
                          <p
                            :class="`${
                              item.aprovada == null
                                ? 'break-words'
                                : 'text-white break-words'
                            }`"
                          >
                            {{ item.observacaoVistoria }}
                          </p>
                        </div>

                        <h5
                          v-if="item.aprovada == false && item.motivoReprovacao"
                          class="text-center text-white p-4 mb-3"
                        >
                          {{ item.motivoReprovacao }}
                        </h5>
                      </div>
                      <div
                        slot="footer"
                        v-if="
                          responsavelVistoria &&
                          isOpenInspection &&
                          item.isCurrentAnalysis
                        "
                      >
                        <vs-row vs-justify="flex-end">
                          <vs-button
                            v-tooltip="'Recusar Foto'"
                            @click="openPrompt(item)"
                            type="gradient"
                            color="danger"
                            icon="thumb_down"
                            v-if="
                              $can($actionsDefault.Escrita, subjectPermission)
                            "
                          ></vs-button>
                          <vs-button
                            v-tooltip="'Aprovar Foto'"
                            @click="aprovarFoto(item)"
                            v-if="
                              $can($actionsDefault.Escrita, subjectPermission)
                            "
                            type="gradient"
                            color="success"
                            icon="thumb_up"
                            data-testId="approve-photo-button"
                          ></vs-button>
                        </vs-row>
                      </div>
                    </vs-card>
                  </vs-col>
                </vs-row>
              </div>
              <br class="break" />
            </vs-card>
          </vs-col>
        </vs-row>
      </div>

      <Modal
        class="holamundo"
        :title="'Local da Foto'"
        :active.sync="openModalMapa"
        @close="itemMapaModal = null"
        data-testId="open-map-popup"
      >
        <iframe
          v-if="itemMapaModal"
          width="100%"
          height="170"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
          :src="`https://maps.google.com/maps?q=${itemMapaModal.latitude},${itemMapaModal.longitude}&hl=pt-br&z=15&amp;output=embed`"
        ></iframe>
      </Modal>

      <Modal
        :title="
          isAprovarTodas ? 'Aprovar todas as Fotos' : 'Reprovar todas as Fotos'
        "
        @cancel="isAprovarTodas = null"
        @close="promptAprovarReprovar = false"
        :active.sync="promptAprovarReprovar"
        data-testId="approve-all-popup"
      >
        <vs-alert
          style="height: auto"
          title="Atenção"
          active="true"
          color="danger"
        >
          Ao Clicar no botão abaixo, todas as fotos sem aprovação/reprovação
          serão impactadas
        </vs-alert>
        <vs-button
          @click="aprovaReprovaTodas()"
          :color="isAprovarTodas ? 'success' : 'danger'"
          :icon="isAprovarTodas ? 'thumb_up' : 'thumb_down'"
          class="mb-2 my-5 btn-block"
          data-testId="approve-all-confirm-button"
        >
          <span>{{
            isAprovarTodas
              ? 'Aprovar todas as Fotos'
              : 'Reprovar todas as Fotos'
          }}</span>
        </vs-button>
      </Modal>

      <Modal
        :fullscreen="isFullscreen"
        class="holamundo"
        :title="'Foto'"
        :active.sync="openModal"
        @close="closePop"
        data-testId="photo-popup"
      >
        <div v-if="imgModal">
          <!-- <form role="form"> -->
          <vs-row
            vs-align="flex-end"
            vs-type="flex"
            vs-justify="center"
            vs-w="12"
          >
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              class="sm:p-2 p-4 flex-col"
            >
              <h4>{{ itemModalIndex + 1 }} - {{ itemModal.nomePosicao }}</h4>
            </vs-col>
          </vs-row>
          <vs-row
            vs-align="flex-end"
            vs-type="flex"
            vs-justify="center"
            vs-w="12"
          >
            <!-- <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="3"
          class="sm:p-2 p-4 flex-col"
        >
          <span class="z-40 bg-white px-3 rounded">Zoom</span>
          <vs-switch color="success" v-model="zoomFotoSwitch" class="z-40">
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </vs-col> -->
            <vs-col
              v-if="tipoModal == 'Foto'"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="2"
              class="sm:p-2 p-4 gap-x-1 z-40"
            >
              <vs-button
                icon-pack="feather"
                icon="icon-arrow-left"
                :color="'warning'"
                class="z-40"
                @click="mudaFoto('anterior')"
              />
            </vs-col>
            <vs-col
              v-if="tipoModal == 'Foto'"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="3"
              class="sm:p-2 p-4 gap-x-1 z-40"
            >
              <vs-button
                icon-pack="feather"
                icon="icon-rotate-ccw"
                :color="'primary'"
                class="z-40"
                @click="rotateLeft"
              />
              <div
                class="z-40 bg-white px-3 rounded flex flex-col items-center"
              >
                <span>Zoom</span>
                <vs-switch
                  color="success"
                  v-model="zoomFotoSwitch"
                  data-testId="zoom-switch"
                >
                  <span slot="on">Sim</span>
                  <span slot="off">Não</span>
                </vs-switch>
              </div>
              <vs-button
                icon-pack="feather"
                icon="icon-rotate-cw"
                :color="'primary'"
                class="z-40"
                @click="rotateRight"
                data-testId="rotate-button"
              />
            </vs-col>
            <vs-col
              v-if="tipoModal == 'Foto'"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="2"
              class="sm:p-2 p-4 gap-x-1 z-40"
            >
              <vs-button
                icon-pack="feather"
                icon="icon-arrow-right"
                :color="'warning'"
                class="z-40"
                @click="mudaFoto('próximo')"
                data-testId="change-photo-button"
              />
            </vs-col>
          </vs-row>
          <vs-row class="flex justify-center text-red-600">
            <p class="text-red-600">
              {{
                this.dadosProposta.idStatus === STATUS_PROPOSTA.FINALIZADO.id
                  ? 'Não é possível editar os dados de uma proposta finalizada.'
                  : null
              }}
            </p></vs-row
          >
          <vs-row vs-type="flex" vs-justify="right" vs-w="12">
            <vs-col
              v-if="itemModal.nomePosicao == 'CNH' && tipoModal == 'Foto'"
              vs-justify="center"
              vs-w="2"
              vs-align="center"
              class="mt-4"
            >
              <div class="mt-8">
                <div>
                  <p><b>NOME:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Nome"
                    id="nome"
                    v-model="form.dadosClientePessoal.associado"
                    v-validate="{ required: true }"
                    :state="validateState('Nome')"
                    :danger="validateClass('Nome')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                    data-testId="insured-name-input"
                  />
                </div>
                <div
                  v-if="this.dadosProposta.dadosCliente.tipo == 'Pessoa Física'"
                >
                  <div class="mt-2 mb-2">
                    <vs-checkbox
                      v-model="form.dadosClientePessoal.associadoNomeSocial"
                      data-testId="insured-social-name-switch"
                    >
                      <b>NOME SOCIAL?</b>
                    </vs-checkbox>
                  </div>
                  <div v-if="form.dadosClientePessoal.associadoNomeSocial">
                    <p><b>NOME CIVIL</b></p>
                    <vs-input
                      size="medium"
                      class="w-full"
                      name="Nome Civil"
                      id="Nome Civil"
                      v-model="form.dadosClientePessoal.associadoNomeCivil"
                      v-validate="{ required: true }"
                      :state="validateState('Nome Civil')"
                      :danger="validateClass('Nome Civil')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="disableSwitch"
                      data-testId="insured-civil-name-input"
                    />
                  </div>
                  <div class="mt-1">
                    <p><b>RG:</b></p>
                    <vs-input
                      size="medium"
                      class="w-full"
                      name="RG"
                      id="RG"
                      v-model="form.dadosClientePessoal.rg_ie"
                      v-validate="{ required: true }"
                      :state="validateState('RG')"
                      :danger="validateClass('RG')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="disableSwitch"
                      data-testId="insured-rg-input"
                    />
                  </div>
                  <div class="mt-1">
                    <p><b>CPF:</b></p>
                    <vs-input
                      size="medium"
                      class="w-full"
                      name="CPF"
                      id="CPF"
                      v-model="form.dadosClientePessoal.cpfCnpj"
                      v-mask="'###.###.###-##'"
                      v-validate="{ required: true }"
                      :state="validateState('CPF')"
                      :danger="validateClass('CPF')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="disableSwitch"
                      data-testId="insured-rg-input"
                    />
                  </div>
                  <div class="mt-1">
                    <p><b>DATA DE NASCIMENTO:</b></p>
                    <vs-input
                      size="medium"
                      class="w-full"
                      name="Data de Nascimento"
                      id="dataNascimento"
                      v-model="form.dadosClientePessoal.dataNascimento"
                      v-validate="{ required: true, date_format: 'dd/mm/yyyy' }"
                      :state="validateState('Data de Nascimento')"
                      :danger="validateClass('Data de Nascimento')"
                      val-icon-danger="clear"
                      danger-text="Preencha com uma data válida usando o formato DD/MM/AAAA"
                      :disabled="disableSwitch"
                      data-testId="insured-birth-date-input"
                    />
                  </div>
                </div>
                <div
                  v-if="
                    this.dadosProposta.dadosCliente.tipo == 'Pessoa Jurídica'
                  "
                >
                  <div class="mt-1">
                    <p><b>INSCRIÇÃO ESTADUAL:</b></p>
                    <vs-input
                      size="medium"
                      class="w-full"
                      name="IE"
                      id="IE"
                      v-model="form.dadosClientePessoal.rg_ie"
                      v-validate="{ required: true }"
                      :state="validateState('IE')"
                      :danger="validateClass('IE')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="disableSwitch"
                      data-testId="insured-state-registration-input"
                    />
                  </div>
                  <div class="mt-1">
                    <p><b>CNPJ:</b></p>
                    <vs-input
                      size="medium"
                      class="w-full"
                      name="CNPJ"
                      id="CNPJ"
                      v-model="form.dadosClientePessoal.cpfCnpj"
                      v-mask="'##.###.###/####-##'"
                      v-validate="{ required: true }"
                      :state="validateState('CNPJ')"
                      :danger="validateClass('CNPJ')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="disableSwitch"
                      data-testId="insured-cnpj-input"
                    />
                  </div>
                  <div class="mt-1">
                    <p><b>CPF DO REP. LEGAL:</b></p>
                    <vs-input
                      size="medium"
                      class="w-full"
                      name="CPF Representante"
                      id="cpfRepresentante"
                      v-model="form.dadosClientePessoal.cpfRepresentante"
                      v-mask="'###.###.###-##'"
                      v-validate="{ required: true }"
                      :state="validateState('CPF Representante')"
                      :danger="validateClass('CPF Representante')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="disableSwitch"
                      data-testId="insured-legal-representative-cpf-input"
                    />
                  </div>
                  <div class="mt-1">
                    <p><b>NOME DO REP. LEGAL:</b></p>
                    <vs-input
                      size="medium"
                      class="w-full"
                      name="Nome Representante"
                      id="nomeRepresentante"
                      v-model="form.dadosClientePessoal.representanteLegal"
                      v-validate="{ required: true }"
                      :state="validateState('Nome Representante')"
                      :danger="validateClass('Nome Representante')"
                      val-icon-danger="clear"
                      danger-text="Preencha este Campo"
                      :disabled="disableSwitch"
                      data-testId="insured-legal-representative-name-input"
                    />
                  </div>
                </div>
                <div class="mt-1">
                  <p><b>CNH:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="CNH"
                    id="CNH"
                    v-model="form.dadosClientePessoal.cnh"
                    v-validate="{ required: true, max: 11, min: 11 }"
                    :state="validateState('CNH')"
                    :danger="validateClass('CNH')"
                    val-icon-danger="clear"
                    danger-text="Preencha os 11 dígitos da CNH"
                    :disabled="disableSwitch"
                    data-testId="insured-legal-representative-cnh-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>DATA DE VALIDADE:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Data de Validade"
                    id="dataValidade"
                    v-model="form.dadosClientePessoal.dataVencimentoCnh"
                    v-validate="{ required: true, date_format: 'dd/mm/yyyy' }"
                    :state="validateState('Data de Validade')"
                    :danger="validateClass('Data de Validade')"
                    val-icon-danger="clear"
                    danger-text="Preencha com uma data válida usando o formato DD/MM/AAAA"
                    :disabled="disableSwitch"
                    data-testId="due-date-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>EMAIL:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Email"
                    id="email"
                    v-model="form.dadosClientePessoal.email"
                    v-validate="{ required: true, email: true }"
                    :state="validateState('Email')"
                    :danger="validateClass('Email')"
                    val-icon-danger="clear"
                    danger-text="Preencha um email válido"
                    :disabled="disableSwitch"
                    data-testId="insured-email-input"
                  />
                </div>
                <div v-if="!disableSwitch">
                  <vs-button
                    @click="onSubmit('dadosPessoais')"
                    color="success"
                    type="gradient"
                    class="mt-2 mb-2"
                    :disabled="disableSwitch"
                    data-testId="save-insured-button"
                    >Salvar Alterações
                  </vs-button>
                </div>
              </div>
            </vs-col>
            <vs-col
              v-if="
                itemModal.nomePosicao == 'DUT - Documento do Veículo' &&
                tipoModal == 'Foto'
              "
              vs-justify="center"
              vs-w="2"
              vs-align="center"
              class="mt-4"
            >
              <div class="mt-8">
                <div class="mt-1">
                  <p><b>MARCA:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    v-model="dadosProposta.dadosVeiculo.veiculoMarca"
                    :disabled="true"
                    data-testId="vehicle-brand-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>MODELO:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    v-model="dadosProposta.dadosVeiculo.veiculoModelo"
                    :disabled="true"
                    data-testId="vehicle-model-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>COMBUSTÍVEL:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    v-model="dadosProposta.dadosVeiculo.combustivel"
                    :disabled="true"
                    data-testId="vehicle-fuel-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>ANO DE FABRICAÇÃO:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    v-model="dadosProposta.dadosVeiculo.anoFabricacao"
                    :disabled="true"
                    data-testId="vehicle-manufacturing-year-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>ANO DO MODELO:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    v-model="dadosProposta.dadosVeiculo.anoModelo"
                    :disabled="true"
                    data-testId="vehicle-model-year-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>ANO DE EXERCÍCIO:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Ano de Exercicio"
                    id="anoExercicio"
                    v-model="form.dadosVeiculo.anoExercicioDut"
                    v-validate="{
                      required: true,
                      min: 4,
                      max: 4,
                      numeric: true,
                      date_format: 'yyyy',
                    }"
                    :state="validateState('Ano de Exercicio')"
                    :danger="validateClass('Ano de Exercicio')"
                    val-icon-danger="clear"
                    danger-text="Digite o ano com quatro dígitos"
                    :disabled="disableSwitch"
                    data-testId="vehicle-year-exercise-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>RENAVAM:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Renavam"
                    id="renavam"
                    v-model="form.dadosVeiculo.renavam"
                    v-validate="{ required: true }"
                    :state="validateState('Renavam')"
                    :danger="validateClass('Renavam')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                    data-testId="vehicle-renavam-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>COR PREDOMINANTE:</b></p>
                  <v-select
                    :options="listaCores"
                    name="Cor"
                    id="cor"
                    size="medium"
                    v-model="form.dadosVeiculo.cor"
                    v-validate="{ required: true }"
                    :state="validateState('Cor')"
                    :class="validateClass('Cor')"
                    :disabled="disableSwitch"
                    data-testId="vehicle-color-input"
                  ></v-select>
                </div>
                <div class="mt-1">
                  <p><b>PLACA:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Placa"
                    id="placa"
                    v-model="form.dadosVeiculo.placa"
                    v-validate="{ required: true }"
                    :state="validateState('Placa')"
                    :danger="validateClass('Placa')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                    data-testId="vehicle-license-plate-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>TIPO DE CÂMBIO:</b></p>
                  <v-select
                    :options="listaCambios"
                    name="Tipo de Câmbio"
                    id="tipoCambio"
                    size="medium"
                    v-model="form.dadosVeiculo.tipoCambio"
                    v-validate="{ required: true }"
                    :state="validateState('Tipo de Câmbio')"
                    :class="validateClass('Tipo de Câmbio')"
                    :disabled="disableSwitch"
                    data-testId="vehicle-transmission-input"
                  ></v-select>
                </div>
                <div class="mt-1">
                  <p><b>NÚMERO DO MOTOR:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Número do Motor"
                    id="numeroMotor"
                    v-model="form.dadosVeiculo.numeroMotor"
                    v-validate="{ required: true }"
                    :state="validateState('Número do Motor')"
                    :danger="validateClass('Número do Motor')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                    data-testId="vehicle-motor-number-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>CHASSI:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Chassi"
                    id="chassi"
                    v-model="form.dadosVeiculo.chassi"
                    v-validate="{ required: true }"
                    :state="validateState('Chassi')"
                    :danger="validateClass('Chassi')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                    data-testId="vehicle-chassis-input"
                  />
                </div>
                <div v-if="!disableSwitch">
                  <vs-button
                    @click="onSubmit('dadosVeiculo')"
                    color="success"
                    type="gradient"
                    class="mt-2 mb-2"
                    :disabled="disableSwitch"
                    data-testId="save-vehicle-data-button"
                    >Salvar Alterações
                  </vs-button>
                </div>
              </div>
            </vs-col>
            <vs-col
              v-if="
                itemModal.nomePosicao == 'Comprovante de Endereço' &&
                tipoModal == 'Foto'
              "
              vs-justify="center"
              vs-w="2"
              vs-align="center"
              class="mt-4"
            >
              <div class="mt-8">
                <div class="mt-1">
                  <p><b>ENDEREÇO:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Endereço"
                    id="endereco"
                    v-model="form.dadosClienteEndereco.endereco"
                    v-validate="{ required: true }"
                    :state="validateState('Endereço')"
                    :danger="validateClass('Endereço')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                    data-testId="address-street-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>NÚMERO:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Número"
                    id="numero"
                    v-model="form.dadosClienteEndereco.numero"
                    v-validate="{ required: true }"
                    :state="validateState('Número')"
                    :danger="validateClass('Número')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                    data-testId="address-number-input"
                  />
                </div>
                <div class="mt-1">
                  <p>
                    <b>COMPLEMENTO:</b>
                  </p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Complemento"
                    id="complemento"
                    v-model="form.dadosClienteEndereco.complemento"
                    :state="validateState('Complemento')"
                    :danger="validateClass('Complemento')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                    data-testId="address-complement-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>BAIRRO:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Bairro"
                    id="bairro"
                    v-model="form.dadosClienteEndereco.bairro"
                    v-validate="{ required: true }"
                    :state="validateState('Bairro')"
                    :danger="validateClass('Bairro')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                    data-testId="address-neighborhood-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>CIDADE:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    v-model="dadosProposta.dadosCliente.cidade"
                    :disabled="true"
                    data-testId="address-city-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>ESTADO:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    v-model="dadosProposta.dadosCliente.estado"
                    :disabled="true"
                    data-testId="address-state-input"
                  />
                </div>
                <div class="mt-1">
                  <p><b>CEP:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    v-model="dadosProposta.dadosCliente.cep"
                    :disabled="true"
                    data-testId="address-cep-input"
                  />
                </div>
                <div v-if="!disableSwitch">
                  <vs-button
                    @click="onSubmit('dadosEndereco')"
                    color="success"
                    type="gradient"
                    class="mt-2 mb-2"
                    :disabled="disableSwitch"
                    data-testId="save-address-data-button"
                    >Salvar Alterações
                  </vs-button>
                </div>
              </div>
            </vs-col>
            <vs-col
              v-if="itemModal.nomePosicao == 'Chassi' && tipoModal == 'Foto'"
              vs-justify="center"
              vs-w="2"
              vs-align="center"
              class="mt-4"
            >
              <div class="mt-8">
                <div class="mt-1">
                  <p><b>CHASSI:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Chassi"
                    id="chassi"
                    v-model="form.dadosVeiculo.chassi"
                    v-validate="{ required: true }"
                    :state="validateState('Chassi')"
                    :danger="validateClass('Chassi')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                    data-testId="chassis-input"
                  />
                </div>
                <vs-button
                  @click="onSubmit('dadosVeiculo')"
                  color="success"
                  type="gradient"
                  class="mt-2 mb-2"
                  :disabled="disableSwitch"
                  data-testId="save-chassis-data-button"
                  >Salvar Alterações
                </vs-button>
              </div>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              :vs-w="
                (itemModal.nomePosicao == 'CNH' ||
                  itemModal.nomePosicao == 'DUT - Documento do Veículo' ||
                  itemModal.nomePosicao == 'Comprovante de Endereço' ||
                  itemModal.nomePosicao == 'Chassi') &&
                tipoModal == 'Foto'
                  ? '10'
                  : '12'
              "
              class="sm:p-2 p-4"
              :class="rotate"
            >
              <video
                class="video"
                style="max-height: 800px; margin: auto; display: flex"
                v-if="verificaExtensaoVideo(imgModal)"
                controls
                muted
                loop
                :src="imgModal"
              ></video>
              <img
                v-if="verificaExtensaoImagem(imgModal)"
                :src="imgModal"
                :width="zoomFotoModal"
                :height="zoomFotoModal"
                style="max-width: 100%; max-height: 100%; object-fit: contain"
              />
              <iframe
                v-else-if="!verificaExtensaoVideo(imgModal)"
                :src="itemModal.nome"
                width="100%"
                height="600px"
                style="border: none"
              >
              </iframe>
            </vs-col>
          </vs-row>
          <div v-if="itemModal.observacaoVistoria">
            <span :class="`${itemModal.aprovada == null ? '' : 'text-white'}`"
              ><b>Observação:</b></span
            >
            <p
              :class="`${
                itemModal.aprovada == null
                  ? 'break-words'
                  : 'text-white break-words'
              }`"
            >
              {{ itemModal.observacaoVistoria }}
            </p>
          </div>
          <div
            class="flex justify-end gap-x-1"
            v-if="
              responsavelVistoria &&
              tipoModal == 'Foto' &&
              isOpenInspection &&
              itemModal.isCurrentAnalysis
            "
          >
            <vs-button
              v-tooltip="'Recusar Foto'"
              type="gradient"
              color="danger"
              icon="thumb_down"
              @click="openPrompt(itemModal)"
              data-testId="reject-photo-button"
            />
            <vs-button
              v-tooltip="'Aprovar Foto'"
              type="gradient"
              color="success"
              icon="thumb_up"
              @click="aprovarFoto(itemModal)"
              data-testId="approve-photo-button"
            />
          </div>
        </div>
        <!-- </form> -->
      </Modal>
      <Modal
        :title="'Motivo de Reprovação'"
        @cancel="motivoReprovacao = null"
        @close="activePrompt = false"
        :active.sync="activePrompt"
        class="popupFront"
        data-testId="reject-photo-reason-popup"
      >
        <div class="con-exemple-prompt">
          <vs-textarea
            placeholder="Pendência na vistoria"
            v-model="motivoReprovacao"
          />
        </div>
        <vs-button
          @click="reprovarFoto()"
          color="dark"
          class="mb-2 my-5 btn-block"
          data-testId="reject-photo-reason-popup-save-button"
        >
          <span>Reprovar Foto</span>
        </vs-button>
      </Modal>

      <Modal
        :title="'Motivo de Reprovação'"
        @cancel="motivoReprovacaoGeral = null"
        @close="activePromptGeral = false"
        :active.sync="activePromptGeral"
        data-testId="reject-all-reason-popup"
      >
        <div class="con-exemple-prompt">
          <!-- <span>Refazer a Assinatura</span>
          <vs-switch
            color="success"
            v-model="refazerAssinatura"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch> -->
          <vs-textarea
            class="mt-5"
            placeholder="Pendência na vistoria"
            v-model="motivoReprovacaoGeral"
            data-testId="reject-all-reason-popup-textarea"
          />
        </div>
        <vs-button
          @click="reprovarGeral()"
          color="dark"
          class="mb-2 my-5 btn-block"
          data-testId="reject-all-reason-popup-save-button"
        >
          <span>Reprovar Vistoria</span>
        </vs-button>
      </Modal>

      <Modal
        :title="'Ativar Apólice'"
        @close="showConfirmApprovalModal = false"
        :active.sync="showConfirmApprovalModal"
        data-testId="activate-policy-popup"
      >
        <div class="con-exemple-prompt">
          <span style="font-size: 16px"
            >Tem certeza que deseja ativar essa apólice?</span
          >
          <center>
            <vs-button
              @click="aprovarGeral()"
              color="success"
              class="mb-12 mt-12 mr-2 btn-block"
              data-testId="activate-policy-popup-save-button"
            >
              <span>Ativar apólice</span>
            </vs-button>

            <vs-button
              @click="showConfirmApprovalModal = false"
              color="grey"
              class="mb-12 mt-12 ml-2 btn-block"
              data-testId="activate-policy-popup-cancel-button"
            >
              <span>Cancelar</span>
            </vs-button>
          </center>
        </div>
      </Modal>

      <Modal
        :title="'Aprovar Proposta'"
        @cancel="diaVencimentoMensalidade = null"
        @close="activePromptGeralAprovar = false"
        :active.sync="activePromptGeralAprovar"
        class="popupMaior"
        data-testId="approve-all-popup"
      >
        <div v-if="activePromptGeralAprovar">
          <div
            class="mb-4"
            v-if="
              !dadosProposta.dadosVeiculo.chassi &&
              dadosProposta.idTipoApolice == TIPO_APOLICE.AUTO
            "
          >
            <vs-alert
              style="height: auto"
              title="Atenção"
              active="true"
              color="danger"
              class="mb-4"
            >
              A Vistoria esta sem os dados completos do veículo
            </vs-alert>
          </div>

          <div v-else>
            <div
              v-if="
                !dadosProposta.assinatura &&
                assinaturaLiberada == false &&
                dadosProposta.idTipoApolice != TIPO_APOLICE.RCVAT
              "
            >
              <div class="mb-4">
                <vs-alert
                  style="height: auto"
                  title="Atenção"
                  active="true"
                  color="danger"
                  class="mb-4"
                >
                  A Vistoria esta sem assinatura, solicite ao Associado que faça
                  a assinatura pelo APP ou procure o administrador do sistema
                  para liberar a vistoria sem assinatura.
                </vs-alert>
                <div class="vx-row mt-3" style="justify-content: space-evenly">
                  <div class="vs-col">
                    <div
                      v-if="
                        $can(
                          'Aprovar Vistoria sem Assinatura',
                          subjectPermission,
                        )
                      "
                    >
                      <span>Liberar Assinatura?</span>
                      <vs-switch
                        color="success"
                        v-model="assinaturaLiberada"
                        style="width: 60px"
                        data-testId="signature-switch"
                      >
                        <span slot="on">Sim</span>
                        <span slot="off">Não</span>
                      </vs-switch>
                    </div>
                  </div>
                  <div class="vx-coll">
                    <div
                      v-if="$can('Aprovar proposta sem vistoria', 'Cotações')"
                      v-show="fotosGerais.length > 0"
                    >
                      <span>Aprovar propostas sem vistoria?</span>
                      <vs-switch
                        color="success"
                        v-model="aprovarPropostaSemFotos"
                        style="width: 60px"
                        data-testId="approve-without-inspection-switch"
                      >
                        <span slot="on">Sim</span>
                        <span slot="off">Não</span>
                      </vs-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="dadosProposta.idTipoApolice == TIPO_APOLICE.VIDA"
              class="con-exemple-prompt"
            >
              <span
                >Tem certeza que deseja aprovar a documentação e ativar essa
                apólice?</span
              >

              <center>
                <vs-button
                  @click="aprovarGeral()"
                  color="success"
                  class="mb-12 mt-12 mr-2 btn-block"
                  data-testId="approve-general-popup"
                >
                  <span>Aprovar Vistoria</span>
                </vs-button>

                <vs-button
                  @click="activePromptGeralAprovar = false"
                  color="primary"
                  class="mb-12 mt-12 ml-2 btn-block"
                  data-testId="approve-general-popup-cancel-button"
                >
                  <span>Cancelar</span>
                </vs-button>
              </center>
            </div>

            <div v-else class="con-exemple-prompt">
              <div class="vx-row mb-6">
                <!-- Cliente vence todo dia: -->
                <div class="vx-col sm:w-1/2 w-full">
                  <label class="mt-4">Cliente vence todo dia:</label>
                  <v-select
                    :options="diasVencimento"
                    name="Cliente vence todo dia:"
                    id="Cliente vence todo dia:"
                    v-model="diaVencimentoMensalidade"
                    v-validate="{ required: true }"
                    :state="validateState('Cliente vence todo dia:')"
                    :class="validateClass('Cliente vence todo dia:')"
                    data-testId="approve-general-popup-due-day-select"
                  ></v-select>
                </div>

                <!-- Data de Ativação -->
                <div class="vx-col sm:w-1/2 w-full">
                  <label>Data de Ativação</label>
                  <div>
                    <flat-pickr
                      name="Data de Ativação"
                      class="input-data-ativacao"
                      v-model="dataAdesaoRealAux"
                      :state="validateState('Data de Ativação')"
                      :class="validateClass('Data de Ativação')"
                      :config="configdateTimePickerDay"
                      placeholder="DD/MM/AAAA"
                      data-testId="approve-general-popup-activate-date-input"
                    />
                  </div>
                </div>
              </div>

              <!-- Valores de Entrada -->
              <div class="vx-row mb-6">
                <div
                  v-if="somaValorTotal(dadosProposta.produtos) > 0"
                  class="vx-col sm:w-1/2 w-full"
                >
                  <label>Os Valores de Entrada vencem:</label>
                  <div>
                    <flat-pickr
                      name="Data de Vencimento"
                      placeholder="DD/MM/AAAA"
                      class="w-full"
                      v-model="dataVencimentoAvistaAux"
                      :config="configdateTimePickerDayEntrada"
                      data-testId="approve-general-popup-due-date-input"
                    />
                  </div>
                </div>
              </div>

              <div class="vx-row" v-if="!verificaEmpresa()">
                <!-- Gera Cobrança? -->
                <div class="vx-col sm:w-1/3 w-full mb-2">
                  <span>Gera Cobrança?</span>
                  <vs-switch
                    color="success"
                    v-model="geraCobranca"
                    style="width: 60px"
                    data-testId="approve-general-popup-generate-bill-switch"
                  >
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                  </vs-switch>
                </div>

                <!-- Participa do Rateio? -->
                <div class="vx-col sm:w-1/3 w-full mb-2">
                  <span>Participa do Rateio?</span>
                  <vs-switch
                    color="success"
                    v-model="participaRateio"
                    style="width: 60px"
                    data-testId="approve-general-popup-participate-bill-switch"
                  >
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                  </vs-switch>
                </div>

                <!-- Boleto Físico? -->
                <div class="vx-col sm:w-1/3 w-full mb-2">
                  <span>Boleto Físico?</span>
                  <vs-switch
                    color="success"
                    v-model="boletoFisico"
                    style="width: 60px"
                    data-testId="approve-general-popup-physical-bill-switch"
                  >
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                  </vs-switch>
                </div>
              </div>

              <center>
                <vs-button
                  @click="aprovarGeral()"
                  color="success"
                  class="mb-12 mt-12 btn-block"
                  data-testId="approve-general-popup-approve-button"
                >
                  <span>Aprovar Vistoria</span>
                </vs-button>
              </center>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        :title="'Erro ao Atualizar a Proposta'"
        @close="modalErrAprovacao = false"
        :active.sync="modalErrAprovacao"
        data-testId="update-error-popup"
      >
        <vs-alert
          style="height: auto"
          title="Atenção"
          active="true"
          color="danger"
        >
          <ul>
            <li v-for="item in errAprovacao" :key="item">{{ item }}</li>
          </ul>
        </vs-alert>

        <vs-button
          v-if="$can($actionsDefault.Escrita, subjectPermission)"
          @click="editarProposta()"
          color="success"
          type="gradient"
          icon-pack="feather"
          icon="icon-edit"
          class="d-inline mt-4"
          data-testId="update-error-popup-edit-button"
          >Editar Dados
        </vs-button>
      </Modal>

      <Modal
        :title="'Upload Manual'"
        @close="modalUpload = false"
        :active.sync="modalUpload"
        data-testId="manual-upload-popup"
      >
        <vs-alert
          style="height: auto"
          title="Atenção"
          active="true"
          color="danger"
          >Ao fazer upload manual, você assume o risco por possíveis fraudes.
        </vs-alert>
        <formUploadVistoria
          :fotos="fotosGerais"
          :idProposta="$route.params.idCotacao"
          @uploaded="uploaded"
          @fechaModalUploadManual="closeModalUploadManual"
        >
        </formUploadVistoria>
      </Modal>

      <Modal
        v-if="dadosProposta && dadosProposta.idApolice"
        id="popup-historico-mensageria"
        :title="'Histórico de Mensageria'"
        :active.sync="modalHistoricoMensageria"
        @close="modalHistoricoMensageria = false"
        data-testId="messaging-history-popup"
      >
        <ModalHistoricoMensageria
          :dadosProposta="dadosProposta"
        ></ModalHistoricoMensageria>
      </Modal>

      <ModalIntegrationLogs
        ref="ModalIntegrationLogs"
        :policyId="dadosProposta.idApolice"
        :policyType="dadosProposta.idTipoApolice"
        :active="activePromptSincronismo"
        @close="activePromptSincronismo = false"
        data-testId="star-sync-popup"
      />

      <ModalDocumentos
        :chave="dadosProposta.chave"
        :active="modalDocumentos"
        :insuranceQuotation="dadosProposta.insurance_quotation"
        :insuranceProposal="dadosProposta.insurance_proposal"
        :insurancePolicy="dadosProposta.insurance_policy"
        :proposalDate="dadosProposta.proposalDate"
        :accessionDate="dadosProposta.dataAdesao"
        :isNewPolicy="isNewPolicy"
        @close="closeModalDocumentos"
        data-testId="documents-popup"
      />
    </div>
    <ModalRefuseProposal
      :policyId="dadosProposta.idApolice"
      :policyTypeId="dadosProposta.idTipoApolice"
      @handleProposalRefused="getProposalData"
      :active="openModalRefuseProposal"
      @close="openModalRefuseProposal = false"
    />
  </div>
</template>

<script>
import { RCVAT } from '@/constants/tipo.apolice';
import endorsementApiService from '@/services/endorsement.api';
import quotationApiService from '@/services/quotation-api';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import jwt from 'jsonwebtoken';
import moment from 'moment';
import flatPickr from 'vue-flatpickr-component';
import 'vue-json-pretty/lib/styles.css';
import vSelect from 'vue-select';
import Modal from '../../components/Modal.vue';
import {
  PERMISSIONS_ACTIONS,
  PERMISSIONS_NAMES,
} from '../../constants/permissions';
import { POLICY_CREATION_TYPE } from '../../constants/tipo.apolice';
import service from '../../services';
import autoApi from '../../services/auto.api';
import lifeApi from '../../services/life-api';
import policyApi from '../../services/policy.api';
import {
  LIFE_KINSHIP,
  POLICY_STATUSES,
  STATUS_PROPOSTA,
  TIPOS_APOLICES,
} from '../../utils/constants';
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import ModalIntegrationLogs from '../modais/integrations/ModalIntegrationLogs.vue';
import ModalDocumentos from '../modais/ModalDocumentos.vue';
import ModalHistoricoMensageria from '../modais/ModalHistoricoMensageria.vue';
import ModalRefuseProposal from '../modais/ModalRefuseProposal.vue';
import formUploadVistoria from './../forms/FormUploadFotoVistoria.vue';
const { TIPO_APOLICE } = require('./../../../common/constant/tipo_apolice');

export default {
  data() {
    return {
      openModalRefuseProposal: false,
      PERMISSIONS_ACTIONS,
      PERMISSIONS_NAMES,
      STATUS_PROPOSTA,
      TIPO_APOLICE: TIPO_APOLICE,
      functions: functions,
      formaPagamentoAtual: null,
      progressPercentage: null,
      progress: null,
      showProgressBar: false,
      implemento: false,
      agregado: false,
      disableSwitch: true,
      listaCores: [],
      listaCambios: ['Automático', 'Manual'],
      zoomFotoModal: '50%',
      zoomFotoSwitch: null,
      itemModal: null,
      itemModalIndex: null,
      tipoModal: null,
      rotate: 'transform rotate-0',
      implementos: [],
      agregados: [],
      idEmpresa: null,
      aprovarPropostaSemFotos: false,
      assinaturaLiberada: false,
      isAprovarTodas: null,
      promptAprovarReprovar: false,
      subjectPermission: 'Vistorias',
      isMounted: false,
      dadosCotacao: null,
      dadosProposta: {},
      dadosRcvat: {},
      logo: null,
      fotos: [],
      openModal: false,
      imgModal: null,
      isFullscreen: true,
      dataVencimentoAvistaAux: null,
      participaRateio: true,
      geraCobranca: true,
      boletoFisico: true,
      filtroFoto: 'Todas',
      tiposFotos: ['Todas', 'Aprovadas', 'Reprovadas', 'Não Trabalhadas'],
      motivoReprovacao: null,
      motivoReprovacaoGeral: '',
      diaVencimentoMensalidade: null,
      qtdRecusa: null,
      dataVencimentoAvista: null,
      refazerAssinatura: null,
      activePrompt: false,
      aprovar: true,
      tamanhoModal: 'width: 900px',
      titleSideBar: 'Situação Financeira',
      dadosClienteFinanceiro: null,
      activePromptGeral: false,
      activePromptGeralAprovar: false,
      activePromptSincronismo: false,
      showConfirmApprovalModal: false,
      itemReprovado: null,
      tipoFoto: null,
      fotosGerais: [],
      logs: [],
      dadosFinanceiros: [],
      openModalMapa: false,
      itemMapaModal: null,
      errAprovacao: [],
      modalErrAprovacao: false,
      modalUpload: false,
      diasVencimento: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      idUsuario: null,
      responsavelVistoria: false,
      verificarGrupo: false,
      dicionarioChassisNacionais: [],
      form: {
        dadosClientePessoal: {
          associado: null,
          associadoNomeSocial: null,
          associadoNomeCivil: null,
          rg_ie: null,
          cpfCnpj: null,
          dataNascimento: null,
          cnh: null,
          dataVencimentoCnh: null,
          email: null,
          idProspect: null,
          representanteLegal: null,
          cpfRepresentante: null,
        },
        dadosClienteEndereco: {
          endereco: null,
          numero: null,
          complemento: null,
          bairro: null,
          idProspect: null,
        },
        dadosVeiculo: {
          anoExercicioDut: null,
          renavam: null,
          cor: null,
          placa: null,
          tipoCambio: null,
          numeroMotor: null,
          chassi: null,
          idProposta: null,
          km: null,
        },
      },
      possuiIntegracaoSGA: false,
      exibirDetalhesVistoria: false,
      itensNaoValidadosVistoria: [],
      naoGerarValoresAvistaIntegracao: false, //param que define se valores avista serão gerados na integracao;
      dataAdesaoRealAux: new Date(),

      // Configurações de Component
      configdateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
      configdateTimePickerDayEntrada: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
        disable: [
          function (date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
          },
        ],
      },

      // SEGURADORA
      STAR: false,
      idProposta: this.$route.params.idCotacao,
      modalHistoricoMensageria: false,
      modalDocumentos: false,
      productsFilters: [],

      endorsementOperationType: null,
      currentPolicyLink: null,
    };
  },
  computed: {
    isOpenInspection() {
      return (
        this.dadosProposta.idStatus ==
          STATUS_PROPOSTA.AGUARDANDO_APROVACAO.id ||
        (this.dadosProposta.idStatus == STATUS_PROPOSTA.EM_TRANSMISSAO.id &&
          this.fotosGerais.length == 0)
      );
    },
    objSend() {
      return {
        idProposta: this.$route.params.idCotacao,
        qtdPorPagina: this.itemsPerPage,
        idEmpresa: this.idEmpresa,
        isInspection: true,
      };
    },
    isNewPolicy() {
      return (
        this.dadosProposta.creationType ===
        POLICY_CREATION_TYPE.NEW_POLICY.value
      );
    },
    POLICY_STATUSES() {
      return POLICY_STATUSES;
    },
    TIPOS_APOLICES() {
      return TIPOS_APOLICES;
    },
    franquiaCasco() {
      const { dadosVeiculo, valorCotaParticipacao, produtos } =
        this.dadosProposta;
      const { valorFipe } = dadosVeiculo;
      const produtosFranquiaEspecial = [1, 15];

      let totalCasco = 0;

      produtos.forEach((produto) => {
        const { id_produto, idProduto } = produto;
        const id = id_produto || idProduto;

        if (produtosFranquiaEspecial.includes(id)) {
          const novoValorFranquia = valorFipe * (valorCotaParticipacao / 100);
          totalCasco += novoValorFranquia;
        }
      });

      return totalCasco;
    },
    dataSincronizacao() {
      return (
        this.dadosProposta.idStatus === STATUS_PROPOSTA.FINALIZADO.id &&
        this.dadosProposta.dataSincronizacaoSga
      );
    },
    needsInspection() {
      return !!this.dadosProposta.inspection_id;
    },
    hasPolicyDocumentBonus() {
      return (
        this.dadosCotacao &&
        this.dadosCotacao.addition_information &&
        this.dadosCotacao.addition_information.policy_document_bonus
      );
    },
    hasInvoiceDocument() {
      return (
        this.dadosCotacao &&
        this.dadosCotacao.vehicle &&
        this.dadosCotacao.vehicle.invoice_document
      );
    },
    editProposalLabel() {
      return this.isAutoPolicy(this.dadosProposta.idTipoApolice)
        ? 'Proposta'
        : 'Editar Dados da Proposta';
    },
    editProposalIcon() {
      return this.isAutoPolicy(this.dadosProposta.idTipoApolice)
        ? 'icon-clipboard'
        : 'icon-edit-2';
    },
  },
  watch: {
    filtroFoto: function () {
      this.filtraFotos();
    },
    aprovarPropostaSemFotos: function (newValue) {
      this.assinaturaLiberada = newValue;
    },
    zoomFotoSwitch: function () {
      if (this.zoomFotoSwitch) {
        this.zoomFotoModal = '100%';
      } else {
        this.zoomFotoModal = '50%';
      }
    },
  },
  methods: {
    handleDuplicatedPhotos(photos) {
      const numRefusals = this.dadosProposta.qtdRecusa || 0;
      if (numRefusals === 0)
        return photos.map((photo) => ({ ...photo, isCurrentAnalysis: true }));

      const counts = new Map();

      return photos.map((photo) => {
        const count = counts.get(photo.id_modeloFoto) || 0;

        if (count >= numRefusals) {
          return { ...photo, isCurrentAnalysis: true };
        }

        counts.set(photo.id_modeloFoto, count + 1);
        return photo;
      });
    },
    openDocument(link) {
      if (link) {
        window.open(link, '_blank');
      }
    },
    getKinshipLabel(kinship) {
      return LIFE_KINSHIP[kinship];
    },
    isLifePolicy(idTipoApolice) {
      return idTipoApolice == TIPO_APOLICE.VIDA;
    },
    isMicroLifePolicy(idTipoApolice) {
      return idTipoApolice == TIPO_APOLICE.MICRO_VIDA;
    },
    isAutoPolicy(idTipoApolice) {
      return idTipoApolice == TIPO_APOLICE.AUTO;
    },
    isNoAutoPolicy(idTipoApolice) {
      return idTipoApolice !== TIPO_APOLICE.AUTO;
    },
    isRcvatPolicy(idTipoApolice) {
      return idTipoApolice == TIPO_APOLICE.RCVAT;
    },
    RCVAT() {
      return RCVAT;
    },
    async findEndorsementOperationType() {
      const response = await endorsementApiService.getOperationTypeByPolicyId(
        this.dadosProposta.idApolice,
      );

      this.endorsementOperationType = response.operationType;
    },
    async findCurrentPolicyLink() {
      try {
        const response = await policyApi.getInsurancePolicyByPolicyNumber(
          this.dadosProposta.policyNumber,
        );
        this.currentPolicyLink = response;
      } catch (error) {
        console.error('Error fetching policy link:', error);
      }
    },
    formatingPrice(price) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(price);
    },
    verificaSefotoFoiAtualizada(dataCriacao, dataAtualizacao) {
      const fotoFoiAtualizada =
        moment(dataCriacao).format('YYYYMMDDHHMMSS') ===
        moment(dataAtualizacao).format('YYYYMMDDHHMMSS');

      const _dataFoto = !fotoFoiAtualizada
        ? this.ajustaDataHoraUtc(dataAtualizacao)
        : this.ajustaDataHoraUtc(dataCriacao);

      return _dataFoto;
    },
    filtraProdutosSelecionadosAgregado(idPropostaComplemento) {
      const { produtosAgregado } = this.agregados.find(
        (item) => item.idPropostaComplemento === idPropostaComplemento,
      );

      return produtosAgregado;
    },
    verificaExtensaoImagem(link) {
      if (link) {
        if (link.split('/')[0] == 'data:image') return true;
        var ext = link.split('.').pop();
        this.tipoFoto = ext;
        if (ext == 'png' || ext == 'jpeg' || ext == 'jpg' || ext == 'gif')
          return true;
        else return false;
      } else return false;
    },
    verificaExtensaoVideo(link) {
      if (link) {
        if (link.split('/')[0] == 'data:video') return true;
        var ext = link.split('.').pop();
        this.tipoFoto = ext;
        if (ext == 'gif' || ext == 'mp4' || ext == 'webm') return true;
        else return false;
      } else return false;
    },
    formataUrlLink(url) {
      if (url) return url.split('/').pop();
    },
    async uploaded() {
      await this.buscaFotos();
      this.buscaFotosPorProposta();
    },
    editarProposta() {
      const link = `/auto/proposta/${this.$route.params.idCotacao}`;
      this.$router.push(link);
      this.modalErrAprovacao = false;
    },

    openModalHistoricoMensageria() {
      this.modalHistoricoMensageria = true;
    },
    openModalDocumentos() {
      this.modalDocumentos = true;
    },
    closeModalDocumentos(pdfs) {
      this.dadosProposta.insurance_quotation = pdfs.insuranceQuotation.link;
      this.dadosProposta.insurance_proposal = pdfs.insuranceProposal.link;
      this.dadosProposta.insurance_policy = pdfs.insurancePolicy.link;
      this.modalDocumentos = false;
    },
    verificaAdmin() {
      const token = localStorage.getItem('user-token');
      if (token) {
        const decoded = jwt.decode(token);
        this.idEmpresa = decoded.id_empresa;
        this.idUsuario = decoded.id_usuario;
      }
    },
    getStatusBoletoColor(data) {
      if (data == 'Finalizado') return 'success';
      if (data == 'Em Aberto') return 'warning';
      if (data == 'Em Processamento') return 'primary';
      if (data == 'Processado com Falha') return 'danger';
      if (data == 'Cancelado') return 'danger';
      if (data == 'Não Processado') return 'dark';
      return 'danger';
    },
    validaVencido(item) {
      if (item.nomeStatus != 'Finalizado' && item.nomeStatus != 'Cancelado') {
        if (moment().diff(moment(item.dataVencimento), 'days') > 0) return true;
      }
      return false;
    },
    formataLink(link) {
      if (!link) return '--';
      if (link.substring(0, 4) == 'http') {
        return '<a href="' + link + '" target="_blank">link</a> ';
      } else return '<span>' + link + '</span>';
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    formataApenasData(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    formataDataUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY HH:mm');
    },
    formataDataUTCAux(data) {
      return moment(data).utc().format('DD/MM/YYYY');
    },
    formataDataMilisegundos(data) {
      return moment(data).format('DD/MM/YYYY HH:mm:ss:SSS');
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    retornaJson(str) {
      return JSON.parse(str);
    },
    aprovaReprovaTodas() {
      this.$vs.loading();
      var objSend = {};
      objSend.idProposta = this.$route.params.idCotacao;
      objSend.isAprovarTodas = this.isAprovarTodas;
      service
        .post('Cotacao', 'aprovarReprovarTodasFotos', objSend)
        .then(() => {
          var filtered = this.fotos.filter((x) => x.aprovada == null);
          filtered.forEach((element) => {
            element.aprovada = this.isAprovarTodas;
          });
          this.promptAprovarReprovar = false;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.promptAprovarReprovar = false;
          this.$vs.loading.close();
        });
    },
    exibeLogs() {
      this.$refs.ModalIntegrationLogs.openModal();
    },
    download(url) {
      window.open(url, '_blank');
    },
    retornaAcessorios(acessorios) {
      return acessorios
        .map((el) => {
          return ' ' + el.descricao;
        })
        .toString();
    },
    cotacaoReprovar() {
      const picturesNotEvaluated = this.fotos.filter((x) => x.aprovada == null);
      const picturesRejected = this.fotos.filter(
        (x) => x.aprovada == false && x.isCurrentAnalysis,
      );

      if (picturesNotEvaluated.length > 0) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível Reprovar a Cotação, existem fotos não Trabalhadas',
          color: 'danger',
        });
        return;
      }
      if (picturesRejected.length === 0) {
        notify.notifyFail(
          this.$vs,
          'Não foi possível reprovar a vistoria. Todas as fotos estão aprovadas.',
        );
        return;
      }
      this.activePromptGeral = true;
    },
    reprovarGeral() {
      this.activePromptGeral = false;
      this.refazerAssinatura = true;
      this.buscaFotosPorProposta().then(() => {
        this.alteraStatusCotacao(STATUS_PROPOSTA.PENDENTE.id);
      });
    },
    cotacaoAprovar() {
      const filtered = this.fotos.filter(
        (x) => x.aprovada == null && x.obrigatorio == false,
      );

      if (filtered.length > 0) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível Aprovar a Cotação, existem fotos não Trabalhadas',
          color: 'danger',
        });
      }
    },
    confirmApproval() {
      this.showConfirmApprovalModal = true;
    },
    async aprovarGeral() {
      this.activePromptGeralAprovar = false;

      if (
        this.isAutoPolicy(this.dadosProposta.idTipoApolice) &&
        !this.needsInspection
      ) {
        this.activatePolicy();
        return;
      }

      this.buscaFotosPorProposta().then(() => {
        const temFotosObrigatorias = this.fotosGerais.filter(
          (foto) => foto.obrigatorio,
        );

        if (temFotosObrigatorias.length === 0) {
          this.isAutoPolicy(this.dadosProposta.idTipoApolice)
            ? this.activatePolicy()
            : this.activateLifePolicy();
          return;
        }

        if (this.dadosProposta.idTipoApolice === TIPO_APOLICE.RCVAT) {
          this.alteraStatusCotacao(STATUS_PROPOSTA.FINALIZADO.id);
          return;
        }

        if (this.fotosGerais.length >= 0 && this.aprovarPropostaSemFotos) {
          this.isAutoPolicy(this.dadosProposta.idTipoApolice)
            ? this.activatePolicy()
            : this.activateLifePolicy();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Proposta aprovada sem vistoria',
            color: 'warning',
            time: 5000,
          });
          return;
        }

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível Aprovar a Cotação, existem fotos Reprovadas',
          color: 'danger',
        });
      });
    },
    activatePolicy() {
      const payload = {
        proposal_id: this.dadosProposta.idProposta,
        policy_type_id: this.dadosProposta.idTipoApolice,
        monthly_due_date: parseInt(this.diaVencimentoMensalidade),
      };

      this.$vs.loading();
      autoApi
        .activatePolicy(payload)
        .then(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Apólice emitida com sucesso.',
            color: 'success',
          });

          setTimeout(() => {
            window.location.reload();
          }, 500);
        })
        .catch((e) => {
          const CARD_ERROR_STATUSES = [403, 409, 422, 423];
          const status = e.response && e.response.status;
          const text = CARD_ERROR_STATUSES.includes(status)
            ? (e.response.data && e.response.data.message) ||
              'Erro ao emitir apólice.'
            : 'Erro ao emitir apólice.';
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text,
            color: 'danger',
          });
        })
        .finally(() => {
          this.showConfirmApprovalModal = false;
          this.$vs.loading.close();
        });
    },
    activateLifePolicy() {
      this.$vs.loading();
      lifeApi
        .activateLifePolicy(this.dadosProposta.idApolice)
        .then((res) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Apólice emitida com sucesso.',
            color: 'success',
          });

          setTimeout(() => {
            window.location.reload();
          }, 500);
        })
        .catch((e) => {
          const CARD_ERROR_STATUSES = [403, 409, 422, 423];
          const status = e.response && e.response.status;
          const text = CARD_ERROR_STATUSES.includes(status)
            ? (e.response.data && e.response.data.message) ||
              'Erro ao emitir apólice.'
            : 'Erro ao emitir apólice.';
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text,
            color: 'danger',
          });
        })
        .finally(() => {
          this.showConfirmApprovalModal = false;
          this.$vs.loading.close();
        });
    },
    alteraStatusCotacao(status) {
      var objSend = {};
      objSend.idProposta = this.$route.params.idCotacao;
      objSend.idStatus = status;
      objSend.qtdRecusa = this.dadosProposta.qtdRecusa
        ? this.dadosProposta.qtdRecusa
        : 0;
      objSend.naoGerarValoresAvistaIntegracao =
        this.naoGerarValoresAvistaIntegracao;
      objSend.idTipoApolice = this.dadosProposta.idTipoApolice;

      if (status == STATUS_PROPOSTA.FINALIZADO.id) {
        objSend.motivoReprovacaoGeral = null;
        objSend.refazerAssinatura = null;
        objSend.diaVencimentoMensalidade = this.diaVencimentoMensalidade;
        objSend.dataVencimentoAvista = moment(
          this.dataVencimentoAvistaAux,
        ).format('DD/MM/YYYY');
        objSend.participaRateio = this.participaRateio;
        objSend.geraCobranca = this.geraCobranca;
        objSend.boletoFisico = this.boletoFisico;
        objSend.dataAdesaoReal = moment(this.dataAdesaoRealAux, 'DD/MM/YYYY')
          .utc()
          .format('YYYY-MM-DD');
      } else {
        objSend.motivoReprovacaoGeral = this.motivoReprovacaoGeral;
        objSend.refazerAssinatura = this.refazerAssinatura;
      }

      if (status == STATUS_PROPOSTA.PENDENTE.id) {
        objSend.motivoReprovacaoGeral = this.motivoReprovacaoGeral;
        (objSend.idUsuario = this.dadosProposta.dadosVendedor.idUsuario),
          (objSend.qtdRecusa = objSend.qtdRecusa + 1);
      }

      objSend.assinaturaLiberada = this.assinaturaLiberada;

      this.$vs.loading();

      service
        .post('Cotacao', 'alteraStatusCotacao', objSend)
        .then(async (res) => {
          if (res.data.success == true) {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Cotação Atualizada com Sucesso',
              color: 'success',
            });

            this.buscaDados();
            this.buscaFotos();
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Falha ao Atualizar Proposta',
              color: 'danger',
            });
            this.errAprovacao = res.data.err;
            this.modalErrAprovacao = true;
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    openPrompt(item) {
      this.activePrompt = true;
      this.itemReprovado = item;
    },
    aprovarFoto(item) {
      this.$vs.loading();
      service
        .post('Cotacao', 'aprovarFoto', item)
        .then(() => {
          const filtered = this.fotos.filter(
            (x) => x.id_PropostaFoto === item.id_PropostaFoto,
          );
          filtered[0].aprovada = true;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    reprovarFoto() {
      this.$vs.loading();
      this.itemReprovado.motivoReprovacao = this.motivoReprovacao;
      service
        .post('Cotacao', 'reprovarFoto', this.itemReprovado)
        .then(() => {
          var filtered = this.fotos.filter(
            (x) => x.id_PropostaFoto == this.itemReprovado.id_PropostaFoto,
          );
          filtered[0].aprovada = false;
          filtered[0].motivoReprovacao = this.motivoReprovacao;
          this.activePrompt = false;
          this.itemReprovado = null;
          this.motivoReprovacao = null;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    filtraFotos() {
      if (this.filtroFoto != 'Todas') {
        var filter = null;
        if (this.filtroFoto == 'Aprovadas')
          filter = this.fotos.filter(
            (x) => x.aprovada == true && x.nome != null,
          );
        if (this.filtroFoto == 'Reprovadas')
          filter = this.fotos.filter(
            (x) => x.aprovada == false && x.nome != null,
          );
        if (this.filtroFoto == 'Não Trabalhadas')
          filter = this.fotos.filter(
            (x) => x.aprovada == null && x.nome != null,
          );
        return filter;
      } else {
        return this.fotos.filter((x) => x.nome != null);
      }
    },
    verificaBg(item) {
      if (item.aprovada == null) return '';
      if (item.aprovada == true) return 'bg-success';
      if (item.aprovada == false) return 'bg-danger';
    },
    openModalFoto(tipo, item) {
      if (
        this.$can(
          'Editar Informações Da Proposta na Foto da Vistoria',
          this.subjectPermission,
        ) &&
        this.dadosProposta.idStatus != 4
      ) {
        this.disableSwitch = false;
      }
      this.preencheForm();
      this.imgModal = item.nome;
      this.isFullscreen = true;
      this.itemModal = item;
      this.tipoModal = 'Foto';
      this.itemModalIndex = this.fotos.findIndex(
        (foto) => foto == this.itemModal,
      );
      this.rotate = 'transform rotate-0';
      if (tipo == 'Padrão') {
        this.tipoModal = 'Padrão';
        this.imgModal =
          'https://bboneapp.s3.amazonaws.com/imgsPadrao/' + item.fotoPadrao;
        this.isFullscreen = false;
      }
      this.openModal = true;
    },
    openModalMap(item) {
      this.itemMapaModal = item;
      this.openModalMapa = true;
    },
    closePop() {
      this.openModal = false;
    },
    somaValorTotal(produtos) {
      if (!produtos) return;

      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal != true) total = total + element.valorFinal;
      });

      if (this.agregado) {
        this.agregados.forEach((agregado) => {
          const { produtosAgregado } = agregado;

          const totalProdutosAgregado = produtosAgregado.reduce(
            (totalSomaProdAgregados, produto) => {
              if (produto.isMensal == false) {
                totalSomaProdAgregados += produto.valorFinal;
              }

              return totalSomaProdAgregados;
            },
            0,
          );

          total += totalProdutosAgregado;
        });
      }

      return total;
    },
    somaValorTotalMes(produtos) {
      if (!produtos) return;

      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal == true) total = total + element.valorFinal;
      });

      if (this.agregado) {
        this.agregados.forEach((agregado) => {
          const { produtosAgregado } = agregado;

          const totalProdutosAgregado = produtosAgregado.reduce(
            (totalSomaProdAgregados, produto) => {
              if (produto.isMensal) {
                totalSomaProdAgregados += produto.valorFinal;
              }

              return totalSomaProdAgregados;
            },
            0,
          );

          total += totalProdutosAgregado;
        });
      }

      return total;
    },
    async buscaFotos() {
      try {
        this.$vs.loading();

        var objSend = {};
        objSend.idProposta = this.$route.params.idCotacao;

        const res = await service.post(
          'Cotacao',
          'listarFotosCotacao',
          objSend,
        );

        this.fotos = this.handleDuplicatedPhotos(res.data);

        this.isMounted = true;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
      }
    },
    buscaFotosPorProposta() {
      return new Promise((resolve, reject) => {
        this.$vs.loading();
        var objSend = {};
        objSend.idProposta = this.$route.params.idCotacao;
        objSend.idEmpresa = this.dadosProposta.idEmpresa;
        objSend.idGrupo = this.dadosProposta.idGrupo;
        objSend.idTipoFipe = this.dadosProposta.dadosVeiculo.codTipoVeiculo;
        objSend.isZero = this.dadosProposta.isZero;
        service
          .post('Cotacao', 'listarTiposFotos', objSend)
          .then((res) => {
            this.fotosGerais = res.data;
            resolve();
            this.$vs.loading.close();
          })
          .catch((e) => {
            reject();
            this.$vs.loading.close();
          });
      });
    },
    buscaDadosFinanceiros() {
      this.$vs.loading();
      var objSend = {};
      objSend.idProposta = this.$route.params.idCotacao;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;
      this.logo = localStorage.getItem('logo');
      service
        .post('Financeiro', 'BuscaDadosFinanceirosProposta', objSend)
        .then((res) => {
          if (res.data.length > 0) {
            this.dadosFinanceiros = res.data;

            this.formaPagamentoAtual = this.dadosFinanceiros.reduce(
              (anterior, atual) => {
                return anterior.id_registroFinanceiro >
                  atual.id_registroFinanceiro
                  ? anterior
                  : atual;
              },
            );

            this.$vs.loading.close();
          } else {
            this.dadosFinanceiros = [];
          }
        })
        .catch(() => {
          this.dadosFinanceiros = [];
          this.$vs.loading.close();
        });
    },
    async getProposalData() {
      const res = await service.post('Cotacao', 'listarCotacoes', this.objSend);
      if (res.data.length > 0) {
        this.dadosProposta = res.data[0];
      }

      if (!this.isNewPolicy) {
        await this.findEndorsementOperationType();
        await this.findCurrentPolicyLink();
      }
    },
    async buscaDados() {
      this.$vs.loading();
      this.logo = localStorage.getItem('logo');

      if (this.objSend.idProposta)
        try {
          await this.getProposalData();

          if (this.dadosProposta) {
            if (this.dadosProposta.idTipoApolice === TIPO_APOLICE.AUTO) {
              await this.getProdutos(this.dadosProposta.idApolice);
            }
            if (this.dadosProposta.implementos) {
              this.implemento = true;
              this.implementos = this.dadosProposta.implementos;
            }
            if (this.dadosProposta.agregados) {
              this.agregados = this.dadosProposta.agregados;
              this.agregado = true;
            }
            this.diaVencimentoMensalidade =
              this.dadosProposta.diaVencimentoMensalidade;
            this.dataVencimentoAvistaAux =
              this.dadosProposta.dataVencimentoAvista;
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            this.$router.push({ name: 'pageError404' });
          }
          if (this.dadosProposta.agregados) {
            this.agregados = this.dadosProposta.agregados;
            this.agregado = true;
          }

          this.diaVencimentoMensalidade =
            this.dadosProposta.diaVencimentoMensalidade;
          this.dataVencimentoAvistaAux =
            this.dadosProposta.dataVencimentoAvista;

          this.verificarResponsavelVistoria(this.dadosProposta.idResponsavel);
          this.verificaEmpresa() && this.verificaGrupoImportados();

          if (this.dadosProposta.idTipoApolice === RCVAT) {
            const rcvatDetails =
              await quotationApiService.getRcvatQuotationDatails(
                this.objSend.idProposta,
                this.dadosProposta.idApolice,
              );

            this.preencheDadosRcvat(rcvatDetails);
          }

          await Promise.all([
            this.buscaFotosPorProposta(),
            this.obterDetalhesVistoria(),
          ]);

          this.$vs.loading.close();
        } catch (error) {
          this.$vs.loading.close();
        }
    },
    preencheDadosRcvat(rcvatDetails) {
      if (rcvatDetails) {
        this.dadosRcvat = {
          id: rcvatDetails.id,
          apoliceId: rcvatDetails.apoliceId,
          vehiclePlatesFilename: rcvatDetails.vehiclePlatesFilename,
          vehiclePlatesUrl: rcvatDetails.vehiclePlatesUrl,
          annualValue: rcvatDetails.annualValue,
          vehicles: rcvatDetails.vehicles.map((vehicle) => ({
            numberOfVehicles: vehicle.numberOfVehicles,
            vehicleType: vehicle.vehicleType,
            vehicleGroup: vehicle.vehicleGroup,
          })),
        };
      }
    },
    verificaEmpresa() {
      return functions.verificaEmpresaBemProtege(this.idEmpresa);
    },
    buscarDicionarioChassisNacionais() {
      service
        .post('dicionarios', 'buscar-dicionario-chassis-nacionais', {})
        .then((res) => {
          this.dicionarioChassisNacionais = res.data;
        })
        .catch((e) => {
          throw new Error(e);
        });
    },
    async verificaGrupoImportados() {
      const veiculoImportado = this.verificaVeiculoImportado();
      const { grupoVeiculosImportados } = this.dadosProposta;
      if (
        (this.verificarGrupoIncorreto(
          veiculoImportado,
          grupoVeiculosImportados,
        ) &&
          (await this.verificarSeExisteGrupoImportado())) ||
        this.verificaPedidoObservacaoGrupo()
      ) {
        this.verificarGrupo = true;
      }
    },
    verificarGrupoIncorreto(veiculoImportado, grupoVeiculosImportados) {
      return (
        (veiculoImportado && !grupoVeiculosImportados) ||
        (!veiculoImportado && grupoVeiculosImportados)
      );
    },
    async verificarSeExisteGrupoImportado() {
      const grupos = await this.buscaGrupos();
      const grupoImportado = grupos.find(
        (grupo) =>
          grupo.importado &&
          this.dadosProposta.dadosVeiculo.codTipoVeiculo === grupo.idTipoFipe,
      );
      return grupoImportado ? true : false;
    },
    verificaVeiculoImportado() {
      if (!this.dadosProposta.dadosVeiculo.chassi) return;

      if (this.dadosProposta.dadosVeiculo.chassi) {
        const chassi = this.dadosProposta.dadosVeiculo.chassi.slice(0, 2);
        return !this.dicionarioChassisNacionais.includes(chassi.toUpperCase());
      } else {
        return false;
      }
    },
    removePedidoRevisaoGrupo() {
      const { observacao, idProposta } = this.dadosProposta;
      if (!observacao) {
        return;
      }

      const fraseRemovida = '. Por favor, revise o grupo';
      const posicaoInicioFraseRemovida = observacao.indexOf(fraseRemovida);
      //a função indexOf retorná a posição na qual começa a frase a ser removida, caso não exista, retornará -1
      if (posicaoInicioFraseRemovida !== -1) {
        const posicaoFimFraseRemovida =
          posicaoInicioFraseRemovida + fraseRemovida.length;

        const novaObservacao =
          observacao.substring(0, posicaoInicioFraseRemovida) +
          observacao.substring(posicaoFimFraseRemovida);

        this.dadosProposta.observacao = novaObservacao;

        this.requsicaoPost(
          { idProposta, observacao: novaObservacao },
          'Grupo',
          'atualiza-tabela-proposta',
        );
      }
    },
    verificaPedidoObservacaoGrupo() {
      const { observacao } = this.dadosProposta;
      const pedidoObservacao = '. Por favor, revise o grupo.';
      return observacao ? observacao.includes(pedidoObservacao) : false;
    },
    requsicaoPost(body, rota, subRota) {
      return service
        .post(rota, subRota, body)
        .then((res) => res.data)
        .catch((e) => {
          throw new Error(e);
        });
    },
    buscaGrupos() {
      const idEmpresa = localStorage.getItem('idEmpresa');
      return service.getAll('Grupo', {}, 'list/' + idEmpresa).then((res) => {
        return res.data.filter((grupo) => grupo.deletedAt === null);
      });
    },
    verificarResponsavelVistoria(id) {
      if (
        this.$can('Assumir Responsabilidade', 'Vistorias') &&
        id === this.idUsuario
      ) {
        this.responsavelVistoria = true;
      }
    },

    async buscaConfigEmpresa() {
      try {
        this.$vs.loading();
        const { data } = await service.getAll(
          'g',
          {},
          'empresas/list/idEmpresa/idEmpresa=null',
        );

        const [dadosEmpresa] = data;

        if (data.length > 0) {
          this.diasVencimento = dadosEmpresa.diasVencimento.split(',');
        }

        const { data: objIntegracao } = await service.getAll(
          'g',
          {},
          `empresaIntegracaoSGA/list/idEmpresa/idEmpresa=null`,
        );

        const [dadosIntegracao] = objIntegracao;

        let temPropNaoGerarValoresAvistaIntegracao = false;
        if (dadosIntegracao) {
          temPropNaoGerarValoresAvistaIntegracao =
            dadosIntegracao.hasOwnProperty('naoGerarValoresAvistaIntegracao');

          if (temPropNaoGerarValoresAvistaIntegracao) {
            this.naoGerarValoresAvistaIntegracao =
              dadosIntegracao.naoGerarValoresAvistaIntegracao;
            this.possuiIntegracaoSGA = true;
          }
        }

        this.$vs.loading.close();
      } catch (error) {
        throw new Error(error);
      }
    },
    rotateRight() {
      if (this.rotate == 'transform rotate-0') {
        this.rotate = 'transform rotate-90';
        return;
      }
      if (this.rotate == 'transform rotate-90') {
        this.rotate = 'transform rotate-180';
        return;
      }
      if (this.rotate == 'transform rotate-180') {
        this.rotate = 'transform -rotate-90';
        return;
      }
      if (this.rotate == 'transform -rotate-90') {
        this.rotate = 'transform rotate-0';
        return;
      }
    },
    rotateLeft() {
      if (this.rotate == 'transform rotate-0') {
        this.rotate = 'transform -rotate-90';
        return;
      }
      if (this.rotate == 'transform -rotate-90') {
        this.rotate = 'transform rotate-180';
        return;
      }
      if (this.rotate == 'transform rotate-180') {
        this.rotate = 'transform rotate-90';
        return;
      }
      if (this.rotate == 'transform rotate-90') {
        this.rotate = 'transform rotate-0';
        return;
      }
    },
    mudaFoto(param) {
      // this.itemModalIndex = this.fotos.findIndex((foto => foto == this.itemModal))
      if (param === 'próximo' && this.itemModalIndex < this.fotos.length - 1) {
        this.itemModal = this.fotos[this.itemModalIndex + 1];
      }
      if (param === 'próximo' && this.itemModalIndex == this.fotos.length - 1) {
        this.itemModal = this.fotos[0];
      }
      if (param === 'anterior' && this.itemModalIndex > 0) {
        this.itemModal = this.fotos[this.itemModalIndex - 1];
      }
      if (param === 'anterior' && this.itemModalIndex == 0) {
        this.itemModal = this.fotos[this.fotos.length - 1];
      }
      this.openModalFoto('Foto', this.itemModal);
    },
    calculaValoresAgregado(isMensal) {
      let total = 0;
      this.agregados.forEach((agregado) => {
        const { produtosAgregado } = agregado;
        const totalProdutosAgregado = produtosAgregado.reduce(
          (totalSomaProdAgregados, produto) => {
            if (produto.isMensal == isMensal) {
              totalSomaProdAgregados += produto.valorFinal;
            }
            return totalSomaProdAgregados;
          },
          0,
        );
        total += totalProdutosAgregado;
      });
      return total;
    },

    buscaCoresECombustivel() {
      this.carregando = true;
      service
        .post('Cotacao', 'listarCoresECombustivel', {
          idRegional: this.dadosProposta.idRegional,
          idProposta: this.$route.params.idCotacao,
        })
        .then((res) => {
          this.listaCores.push({ label: 'Selecione', id: null });
          // this.listaCombustiveis.push({ label: 'Selecione', id: null });

          res.data.cores.forEach((element) => {
            this.listaCores.push({
              label: element.descricao,
              id: element.descricao,
            });
          });

          // res.data.combustiveis.forEach((element) => {
          //   this.listaCombustiveis.push({
          //     label: element.descricao,
          //     id: element.descricao,
          //   });
          // });

          this.carregando = false;
        });
    },
    onSubmit(tipo) {
      let objSend = {};

      if (tipo == 'dadosPessoais') {
        objSend.dadosClientePessoal = this.form.dadosClientePessoal;
      }

      if (tipo == 'dadosVeiculo') {
        objSend.dadosVeiculo = this.form.dadosVeiculo;
      }

      if (tipo == 'dadosEndereco') {
        objSend.dadosClienteEndereco = this.form.dadosClienteEndereco;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          this.$vs.loading();
          service
            .post('Cotacao', 'AtualizarPropostaModal', objSend)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
              this.buscaDados();
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        } else {
          this.aguardeCadastro = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível editar. Favor conferir os campos.',
            color: 'danger',
          });
        }
      });
    },
    preencheForm() {
      this.form.dadosClientePessoal.associado =
        this.dadosProposta.dadosCliente.associado;
      this.form.dadosClientePessoal.rg_ie =
        this.dadosProposta.dadosCliente.rg_ie;
      this.form.dadosClientePessoal.cpfCnpj =
        this.dadosProposta.dadosCliente.cpf;
      this.form.dadosClientePessoal.cnh = this.dadosProposta.dadosCliente.cnh;
      this.form.dadosClientePessoal.dataVencimentoCnh =
        this.dadosProposta.dadosCliente.dataVencimentoCnh;
      this.form.dadosClientePessoal.email =
        this.dadosProposta.dadosCliente.email;
      this.form.dadosClientePessoal.idProspect =
        this.dadosProposta.dadosCliente.idProspect;

      if (this.dadosProposta.dadosCliente.tipo == 'Pessoa Física') {
        this.form.dadosClientePessoal.dataNascimento =
          this.dadosProposta.dadosCliente.dataNascimento;
        this.form.dadosClientePessoal.associadoNomeSocial =
          this.dadosProposta.dadosCliente.associadoNomeSocial;
        this.form.dadosClientePessoal.associadoNomeCivil =
          this.dadosProposta.dadosCliente.associadoNomeCivil;
      }

      if (this.dadosProposta.dadosCliente.tipo == 'Pessoa Jurídica') {
        this.form.dadosClientePessoal.representanteLegal =
          this.dadosProposta.dadosCliente.representanteLegal;
        this.form.dadosClientePessoal.cpfRepresentante =
          this.dadosProposta.dadosCliente.cpfRepresentante;
      }

      // Preenche dados do endereço do cliente
      this.form.dadosClienteEndereco.endereco =
        this.dadosProposta.dadosCliente.endereco;
      this.form.dadosClienteEndereco.numero =
        this.dadosProposta.dadosCliente.numero;
      this.form.dadosClienteEndereco.complemento =
        this.dadosProposta.dadosCliente.complemento;
      this.form.dadosClienteEndereco.bairro =
        this.dadosProposta.dadosCliente.bairro;
      this.form.dadosClienteEndereco.idProspect =
        this.dadosProposta.dadosCliente.idProspect;

      // Preenche dados do veículo do cliente
      this.form.dadosVeiculo.anoExercicioDut =
        this.dadosProposta.dadosVeiculo.anoExercicioDut;
      this.form.dadosVeiculo.renavam = this.dadosProposta.dadosVeiculo.renavam;
      this.form.dadosVeiculo.cor = this.dadosProposta.dadosVeiculo.cor;
      this.form.dadosVeiculo.placa = this.dadosProposta.dadosVeiculo.placa;
      this.form.dadosVeiculo.tipoCambio =
        this.dadosProposta.dadosVeiculo.tipoCambio;
      this.form.dadosVeiculo.numeroMotor =
        this.dadosProposta.dadosVeiculo.numeroMotor;
      this.form.dadosVeiculo.chassi = this.dadosProposta.dadosVeiculo.chassi;
      this.form.dadosVeiculo.idProposta = this.dadosProposta.idProposta;
    },
    ajustaDataHoraUtc(data) {
      return moment.utc(data).local().format('DD/MM/YYYY HH:mm');
    },
    verificaPermissaoUpload() {
      const isEmpresaBp = this.verificaEmpresa();

      // verifica as permissões
      const uploadDuranteAguardandoAprovacao = this.$can(
        'Acesso ao Upload Manual no status Aguardando Aprovação',
        this.subjectPermission,
      );
      const completo = this.$can(
        'Upload Manual Completo',
        this.subjectPermission,
      );
      const documentacao = this.$can(
        'Upload Manual Documentação',
        this.subjectPermission,
      );

      // verifica os status da proposta
      const _idStatusProposta = this.dadosProposta.idStatus;
      const statusPropostaNaoPermiteUpload =
        _idStatusProposta == 2 || _idStatusProposta == 4;

      // const permiteBotaoUploadFixo =
      //   temPermissao && statusPropostaPermiteUpload && isEmpresaBp;

      const permissaoTipoUpload = completo || documentacao;

      // caso não seja um empresa BP o botão não aparece
      if (isEmpresaBp) {
        // Caso o status da proposta seja 'Finalizada' ou 'Recusada', o botão não aparece
        if (statusPropostaNaoPermiteUpload) {
          return false;
        }

        // Caso o usuario não possua a permissão de upload 'Completo' nem 'Manual', o botão não aparece
        else if (!permissaoTipoUpload) {
          return false;
        }

        // Caso o status da cotação seja 'Aguardando Aprovação' verifica a permissão
        // 'Acesso ao Upload Manual no status Aguardando Aprovação'
        else if (_idStatusProposta === 3) {
          return uploadDuranteAguardandoAprovacao;
        }

        // O botão aparece
        else {
          return true;
        }
      }

      return false;
    },
    closeModalUploadManual() {
      this.modalUpload = false;
    },
    validarDadosNaoPreenchidosVistoria(dados, title, icon) {
      this.exibirDetalhesVistoria = true;

      const propriedades = Object.entries(dados);
      const _dadosExibir = {
        title,
        icon,
        propriedades: [],
      };

      propriedades.forEach((item) => {
        const [chave, valor] = item;
        if (valor === null || valor === 'null' || valor === '') {
          const texto = this.desfazCamelCase(chave);
          _dadosExibir.propriedades.push(texto);
        }
      });

      _dadosExibir.key = Math.floor(Math.random() * 100);
      this.itensNaoValidadosVistoria.push(_dadosExibir);
    },
    async obterDetalhesVistoria() {
      try {
        const chave = this.dadosProposta.chave;
        const id = this.dadosProposta.idProposta;
        const idEmpresa = this.dadosProposta.idEmpresa;
        const idGrupo = this.dadosProposta.idGrupo;
        const isZero = this.dadosProposta.isZero;
        const idStatus = this.dadosProposta.idStatus;
        const tipoProposta = this.dadosProposta.tipoProposta;
        const codTipoVeiculo = this.dadosProposta.dadosVeiculo.codTipoVeiculo;
        const somenteAgregado = this.dadosProposta.somenteAgregado;

        const objProposta = {
          tipoProposta,
          codTipoVeiculo,
          somenteAgregado,
        };

        const naoVerificarVistoria = idStatus != 6 && idStatus != 5;

        if (naoVerificarVistoria) {
          return;
        }

        const { data } = await service.post('Vistoria', 'detalhes-vistoria', {
          chave,
          id,
          idEmpresa,
          idGrupo,
          isZero,
        });

        const { assinatura, realizarAssinatura, fotos, agregado, implemento } =
          data;

        const _fotosNaoEnviadas = fotos
          .filter((foto) => foto.nome == null)
          .reduce((acc, item) => {
            const { nomePosicao } = item;

            acc[nomePosicao] = null;
            return acc;
          }, {});

        const temFotosNaoEnviados =
          Object.values(_fotosNaoEnviadas).includes(null);

        if (
          this.dadosProposta.idTipoApolice !== TIPO_APOLICE.AUTO &&
          realizarAssinatura
        ) {
          this.validarDadosNaoPreenchidosVistoria(
            { assinatura },
            'Realizar a assinatura',
            'border_color',
          );
        }

        if (temFotosNaoEnviados) {
          this.validarDadosNaoPreenchidosVistoria(
            _fotosNaoEnviadas,
            'Fotos / Documentos',
            'photo_camera',
          );
        }

        if (agregado) {
          agregado.forEach((_agregado) => {
            const { validatedForm, ...dadosAgregado } = _agregado;

            if (!validatedForm) {
              this.validarDadosNaoPreenchidosVistoria(
                dadosAgregado,
                `Dados do agregado - ${dadosAgregado.descricao}`,
                'local_shipping',
              );
            }
          });
        }

        if (implemento) {
          implemento.forEach((_implemento) => {
            const { validatedForm, ...dadosImplemento } = _implemento;

            if (!validatedForm) {
              this.validarDadosNaoPreenchidosVistoria(
                dadosImplemento,
                `Dados do implemento - ${dadosImplemento.descricao}`,
                'local_shipping',
              );
            }
          });
        }
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Falha ao buscar os de validação da vistoria, tente novamente',
          color: 'danger',
        });
        this.$vs.loading.close();
      }
    },
    validarExcecoes(dados) {
      const excessoesGeral = [
        'telefone',
        'tipo',
        'representanteLegal',
        'cpfRepresentante',
        'naoPossuiCnh',
      ];
      const excessoesProposta = ['placaSubstituicao'];
      const excessoesCarro = ['cilindradas'];
      const excessoesMoto = ['qtdPortas'];
      const excessoesCaminhao = ['cilindradas'];
      const excessoesComplementos = [
        'qtdPortas',
        'combustivel',
        'km',
        'quantidadePassageiro',
        'estadoPneu',
        'tipoCambio',
        'numeroMotor',
        'codTipoVeiculo',
      ];

      this.deletaExcessoes(excessoesGeral, dados);

      if (dados.tipoProposta !== 'Substituicão') {
        this.deletaExcessoes(excessoesProposta, dados);
      }

      if (dados.codTipoVeiculo && dados.codTipoVeiculo === 2) {
        this.deletaExcessoes(excessoesMoto, dados);
      }

      if (dados.codTipoVeiculo && dados.codTipoVeiculo !== 2) {
        this.deletaExcessoes(excessoesCarro, dados);
        this.deletaExcessoes(excessoesCaminhao, dados);
      }

      if (dados.somenteAgregado || dados.agregado || dados.implemento) {
        this.deletaExcessoes(excessoesComplementos, dados);
      }

      return dados;
    },
    deletaExcessoes(excessoes, objDados) {
      excessoes.forEach((excessao) => delete objDados[excessao]);
    },
    capitalizaTexto(texto) {
      return texto[0].toUpperCase() + texto.substring(1);
    },
    desfazCamelCase(str) {
      if (!str || str == 'CNH') {
        return str;
      }

      let result = str[0].toLowerCase();

      for (let i = 1; i < str.length; i++) {
        if (str[i] === str[i].toUpperCase()) {
          result += ' ';
        }

        result += str[i].toLowerCase();
      }

      return this.capitalizaTexto(result);
    },
    getLinkContratoProposta(chave) {
      if (this.dadosProposta.idTipoApolice == TIPO_APOLICE.VIDA) {
        return `/contratoPropostaVida/${chave}`;
      }
      return `/contratoProposta/${chave}`;
    },
    async getProdutos(cod) {
      try {
        this.$vs.loading();

        if (cod) {
          const produtos = await autoApi.getProductsContracted(cod);
          this.dadosCotacao = produtos;
          this.totalProductsPrize = produtos.all_coverages.prize.prize;

          const produtcsFilter = functions.getContractedProductsWithDetails(
            produtos.coverage_contracted,
            produtos.all_coverages.prize,
          );

          this.productsFilters = produtcsFilter;
        }
      } catch (error) {
        await this.$router.push({ name: 'pageError404' });
      } finally {
        this.$vs.loading.close();
      }
    },
    inspectionManager(data) {
      const managerHasDefined = Boolean(data.nomeResponsavel);
      const labelWhenNotAssigned = data.automaticallyIssued
        ? 'System'
        : 'Não definido';
      return managerHasDefined ? data.nomeResponsavel : labelWhenNotAssigned;
    },
  },
  async created() {
    this.verificaAdmin();
    this.idEmpresa = localStorage.getItem('idEmpresa');
    await this.buscaDados();
    this.buscaFotos();
  },
  async mounted() {
    this.buscarDicionarioChassisNacionais();
    this.buscaDadosFinanceiros();
    this.buscaCoresECombustivel();
  },
  components: {
    vSelect,
    formUploadVistoria,
    flatPickr,
    ModalIntegrationLogs,
    ModalHistoricoMensageria,
    Modal,
    ModalDocumentos,
    ModalRefuseProposal,
  },
};
</script>
<style scoped lang="scss">
.popupFront {
  z-index: 53001;
}
.uppercase {
  text-transform: uppercase;
}

.pop-up-fullscreen {
  position: relative;
  top: -10px;
  right: 15px;
  float: right;
}

.assinatura {
  max-width: 100%;
  max-height: 200px;
}

.foto {
  cursor: pointer;
}

@media (max-width: 1161px) {
  .video {
    max-height: 100px !important;
  }
}

@media (max-width: 1395px) {
  .video {
    max-height: 110px !important;
  }
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 2px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.purple-btn {
  background-color: #7b49e7 !important;
}
</style>

<style lang="scss">
@media screen {
  .printer {
    display: none;
  }
}

@media print {
  .table-bordered {
    tr:nth-child(2n) {
      background-color: #ffffff !important;
    }
  }
  .non-printer {
    display: none;
  }
  .vue-back-to-top {
    display: none !important;
  }
  .folha {
    padding: 20px 0 0 0;
    page-break-after: always;
  }
  .btn-print {
    display: none;
  }
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .router-header,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .con-vs-popup {
    .vs-popup {
      width: 1000px !important;
    }
  }

  .vs-popup-content {
    width: 900px !important; //You can change the width according to your content
    height: auto;
  }

  .con-vs-popup .vs-popup {
    width: 70% !important;
  }

  .td-check {
    visibility: hidden;
  }
  .detalheProposta {
    .vs-col {
      width: 100% !important;
    }

    .filtroFotos {
      display: none !important;
    }

    .cardFotos {
      width: 60% !important;

      img {
        height: 100%;
      }

      footer {
        display: none !important;
      }
    }

    h3 {
      button {
        display: none !important;
      }
    }
  }
}

.box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.input-data-ativacao {
  width: 100%;
}

#popup-historico-mensageria {
  .vs-popup {
    width: 1000px !important;
    height: auto;
  }

  .vs-popup--content {
    width: auto !important;
    padding: 1rem;
    font-size: 1rem;
  }
}
.large-icon-button {
  .vs-icon {
    font-size: 1.5rem;
  }
}
</style>
